module.exports = [
	{
		"x": -176.4088872817,
		"y": -64.212999501,
		"ID": 1,
		"h": 1
	},
	{
		"x": -171.4088849507,
		"y": -72.873257577,
		"ID": 2,
		"h": 2.7042730443
	},
	{
		"x": -171.4088849507,
		"y": -67.099752193,
		"ID": 3,
		"h": 4.065811999
	},
	{
		"x": -171.4088849507,
		"y": -61.326246809,
		"ID": 4,
		"h": 1
	},
	{
		"x": -166.4088826197,
		"y": -69.986504885,
		"ID": 5,
		"h": 8.7026297748
	},
	{
		"x": -166.4088826197,
		"y": -64.212999501,
		"ID": 6,
		"h": 13.2770849558
	},
	{
		"x": -166.4088826197,
		"y": -58.439494117,
		"ID": 7,
		"h": 1
	},
	{
		"x": -166.4088826197,
		"y": -41.118977966,
		"ID": 8,
		"h": 1
	},
	{
		"x": -166.4088826197,
		"y": -35.345472582,
		"ID": 9,
		"h": 1
	},
	{
		"x": -161.4088802887,
		"y": -72.873257577,
		"ID": 10,
		"h": 3.2163149229
	},
	{
		"x": -161.4088802887,
		"y": -67.099752193,
		"ID": 11,
		"h": 37.5115417511
	},
	{
		"x": -161.4088802887,
		"y": -61.326246809,
		"ID": 12,
		"h": 12.9225653884
	},
	{
		"x": -161.4088802887,
		"y": -55.552741426,
		"ID": 13,
		"h": 2.8542382224
	},
	{
		"x": -161.4088802887,
		"y": -49.779236042,
		"ID": 14,
		"h": 3.1968893167
	},
	{
		"x": -161.4088802887,
		"y": -44.005730658,
		"ID": 15,
		"h": 2.4959077879
	},
	{
		"x": -161.4088802887,
		"y": -38.232225274,
		"ID": 16,
		"h": 1
	},
	{
		"x": -161.4088802887,
		"y": -32.45871989,
		"ID": 17,
		"h": 1
	},
	{
		"x": -161.4088802887,
		"y": -26.685214507,
		"ID": 18,
		"h": 1
	},
	{
		"x": -161.4088802887,
		"y": -20.911709123,
		"ID": 19,
		"h": 1
	},
	{
		"x": -156.4088779567,
		"y": -69.986504885,
		"ID": 20,
		"h": 1
	},
	{
		"x": -156.4088779567,
		"y": -64.212999501,
		"ID": 21,
		"h": 13.686102608
	},
	{
		"x": -156.4088779567,
		"y": -58.439494117,
		"ID": 22,
		"h": 10.4881912476
	},
	{
		"x": -156.4088779567,
		"y": -52.665988734,
		"ID": 23,
		"h": 7.4606892307
	},
	{
		"x": -156.4088779567,
		"y": -46.89248335,
		"ID": 24,
		"h": 5.6918346583
	},
	{
		"x": -156.4088779567,
		"y": -41.118977966,
		"ID": 25,
		"h": 4.9207731728
	},
	{
		"x": -156.4088779567,
		"y": -35.345472582,
		"ID": 26,
		"h": 4.6104358411
	},
	{
		"x": -156.4088779567,
		"y": -29.571967198,
		"ID": 27,
		"h": 1
	},
	{
		"x": -156.4088779567,
		"y": -23.798461815,
		"ID": 28,
		"h": 1
	},
	{
		"x": -156.4088779567,
		"y": -18.024956431,
		"ID": 29,
		"h": 1
	},
	{
		"x": -151.4088756257,
		"y": -67.099752193,
		"ID": 30,
		"h": 1
	},
	{
		"x": -151.4088756257,
		"y": -61.326246809,
		"ID": 31,
		"h": 4.6513768598
	},
	{
		"x": -151.4088756257,
		"y": -55.552741426,
		"ID": 32,
		"h": 2.3629194043
	},
	{
		"x": -151.4088756257,
		"y": -49.779236042,
		"ID": 33,
		"h": 1
	},
	{
		"x": -151.4088756257,
		"y": -44.005730658,
		"ID": 34,
		"h": 10.5278518871
	},
	{
		"x": -151.4088756257,
		"y": -38.232225274,
		"ID": 35,
		"h": 5.1846935615
	},
	{
		"x": -151.4088756257,
		"y": -32.45871989,
		"ID": 36,
		"h": 3.1895751444
	},
	{
		"x": -151.4088756257,
		"y": -26.685214507,
		"ID": 37,
		"h": 1
	},
	{
		"x": -151.4088756257,
		"y": -20.911709123,
		"ID": 38,
		"h": 4.4502298726
	},
	{
		"x": -151.4088756257,
		"y": -15.138203739,
		"ID": 39,
		"h": 1
	},
	{
		"x": -146.4088732947,
		"y": -58.439494117,
		"ID": 40,
		"h": 1
	},
	{
		"x": -146.4088732947,
		"y": -46.89248335,
		"ID": 41,
		"h": 1
	},
	{
		"x": -146.4088732947,
		"y": -41.118977966,
		"ID": 42,
		"h": 7.6777595066
	},
	{
		"x": -146.4088732947,
		"y": -35.345472582,
		"ID": 43,
		"h": 6.4846473322
	},
	{
		"x": -146.4088732947,
		"y": -29.571967198,
		"ID": 44,
		"h": 4.2211653214
	},
	{
		"x": -146.4088732947,
		"y": -23.798461815,
		"ID": 45,
		"h": 1.6589754418
	},
	{
		"x": -146.4088732947,
		"y": -18.024956431,
		"ID": 46,
		"h": 1
	},
	{
		"x": -146.4088732947,
		"y": -12.251451047,
		"ID": 47,
		"h": 1
	},
	{
		"x": -141.4088709637,
		"y": -44.005730658,
		"ID": 48,
		"h": 1
	},
	{
		"x": -141.4088709637,
		"y": -38.232225274,
		"ID": 49,
		"h": 3.0023490446
	},
	{
		"x": -141.4088709637,
		"y": -32.45871989,
		"ID": 50,
		"h": 5.3179962642
	},
	{
		"x": -141.4088709637,
		"y": -26.685214507,
		"ID": 51,
		"h": 1.9172933887
	},
	{
		"x": -141.4088709637,
		"y": -20.911709123,
		"ID": 52,
		"h": 2.5815977331
	},
	{
		"x": -141.4088709637,
		"y": -15.138203739,
		"ID": 53,
		"h": 1.7770566848
	},
	{
		"x": -141.4088709637,
		"y": -9.364698355,
		"ID": 54,
		"h": 4.2338854361
	},
	{
		"x": -141.4088709637,
		"y": -3.591192971,
		"ID": 55,
		"h": 1
	},
	{
		"x": -136.4088686317,
		"y": -41.118977966,
		"ID": 56,
		"h": 1
	},
	{
		"x": -136.4088686317,
		"y": -35.345472582,
		"ID": 57,
		"h": 6.1457953578
	},
	{
		"x": -136.4088686317,
		"y": -29.571967198,
		"ID": 58,
		"h": 5.1005265858
	},
	{
		"x": -136.4088686317,
		"y": -23.798461815,
		"ID": 59,
		"h": 3.9547694711
	},
	{
		"x": -136.4088686317,
		"y": -18.024956431,
		"ID": 60,
		"h": 2.6288792398
	},
	{
		"x": -136.4088686317,
		"y": -12.251451047,
		"ID": 61,
		"h": 2.3936579917
	},
	{
		"x": -136.4088686317,
		"y": -6.477945663,
		"ID": 62,
		"h": 2.8419403203
	},
	{
		"x": -136.4088686317,
		"y": -0.704440279,
		"ID": 63,
		"h": 1
	},
	{
		"x": -136.4088686317,
		"y": 5.069065104,
		"ID": 64,
		"h": 1
	},
	{
		"x": -136.4088686317,
		"y": 10.842570488,
		"ID": 65,
		"h": 1
	},
	{
		"x": -136.4088686317,
		"y": 16.616075872,
		"ID": 66,
		"h": 1
	},
	{
		"x": -131.4088663007,
		"y": -38.232225274,
		"ID": 67,
		"h": 1
	},
	{
		"x": -131.4088663007,
		"y": -32.45871989,
		"ID": 68,
		"h": 9.9406210086
	},
	{
		"x": -131.4088663007,
		"y": -26.685214507,
		"ID": 69,
		"h": 6.365677928
	},
	{
		"x": -131.4088663007,
		"y": -20.911709123,
		"ID": 70,
		"h": 6.4315425927
	},
	{
		"x": -131.4088663007,
		"y": -15.138203739,
		"ID": 71,
		"h": 4.814286706
	},
	{
		"x": -131.4088663007,
		"y": -9.364698355,
		"ID": 72,
		"h": 2.8827242163
	},
	{
		"x": -131.4088663007,
		"y": -3.591192971,
		"ID": 73,
		"h": 2.885422174
	},
	{
		"x": -131.4088663007,
		"y": 2.182312412,
		"ID": 74,
		"h": 4.9286301621
	},
	{
		"x": -131.4088663007,
		"y": 7.955817796,
		"ID": 75,
		"h": 1.8605318483
	},
	{
		"x": -131.4088663007,
		"y": 13.72932318,
		"ID": 76,
		"h": 1
	},
	{
		"x": -131.4088663007,
		"y": 19.502828564,
		"ID": 77,
		"h": 1
	},
	{
		"x": -126.4088639697,
		"y": -35.345472582,
		"ID": 78,
		"h": 1
	},
	{
		"x": -126.4088639697,
		"y": -29.571967198,
		"ID": 79,
		"h": 14.4776398625
	},
	{
		"x": -126.4088639697,
		"y": -23.798461815,
		"ID": 80,
		"h": 9.1071237319
	},
	{
		"x": -126.4088639697,
		"y": -18.024956431,
		"ID": 81,
		"h": 4.4217625896
	},
	{
		"x": -126.4088639697,
		"y": -12.251451047,
		"ID": 82,
		"h": 4.8378404727
	},
	{
		"x": -126.4088639697,
		"y": -6.477945663,
		"ID": 83,
		"h": 1.4671321361
	},
	{
		"x": -126.4088639697,
		"y": -0.704440279,
		"ID": 84,
		"h": 3.5475068003
	},
	{
		"x": -126.4088639697,
		"y": 5.069065104,
		"ID": 85,
		"h": 2.4417609871
	},
	{
		"x": -126.4088639697,
		"y": 10.842570488,
		"ID": 86,
		"h": 1
	},
	{
		"x": -126.4088639697,
		"y": 16.616075872,
		"ID": 87,
		"h": 1
	},
	{
		"x": -126.4088639697,
		"y": 22.389581256,
		"ID": 88,
		"h": 1
	},
	{
		"x": -121.4088616387,
		"y": -38.232225274,
		"ID": 89,
		"h": 1
	},
	{
		"x": -121.4088616387,
		"y": -32.45871989,
		"ID": 90,
		"h": 29.0446851592
	},
	{
		"x": -121.4088616387,
		"y": -26.685214507,
		"ID": 91,
		"h": 12.2458814508
	},
	{
		"x": -121.4088616387,
		"y": -20.911709123,
		"ID": 92,
		"h": 7.2003099943
	},
	{
		"x": -121.4088616387,
		"y": -15.138203739,
		"ID": 93,
		"h": 5.6786057856
	},
	{
		"x": -121.4088616387,
		"y": -9.364698355,
		"ID": 94,
		"h": 3.213892941
	},
	{
		"x": -121.4088616387,
		"y": -3.591192971,
		"ID": 95,
		"h": 11.9664273993
	},
	{
		"x": -121.4088616387,
		"y": 2.182312412,
		"ID": 96,
		"h": 4.6287666888
	},
	{
		"x": -121.4088616387,
		"y": 7.955817796,
		"ID": 97,
		"h": 2.4658135904
	},
	{
		"x": -121.4088616387,
		"y": 13.72932318,
		"ID": 98,
		"h": 1
	},
	{
		"x": -121.4088616387,
		"y": 19.502828564,
		"ID": 99,
		"h": 2.0524407894
	},
	{
		"x": -121.4088616387,
		"y": 25.276333948,
		"ID": 100,
		"h": 1
	},
	{
		"x": -116.4088593067,
		"y": -41.118977966,
		"ID": 101,
		"h": 1
	},
	{
		"x": -116.4088593067,
		"y": -35.345472582,
		"ID": 102,
		"h": 4.7182262215
	},
	{
		"x": -116.4088593067,
		"y": -29.571967198,
		"ID": 103,
		"h": 7.4538647668
	},
	{
		"x": -116.4088593067,
		"y": -23.798461815,
		"ID": 104,
		"h": 3.3527474009
	},
	{
		"x": -116.4088593067,
		"y": -18.024956431,
		"ID": 105,
		"h": 4.3625152112
	},
	{
		"x": -116.4088593067,
		"y": -12.251451047,
		"ID": 106,
		"h": 3.6104250754
	},
	{
		"x": -116.4088593067,
		"y": -6.477945663,
		"ID": 107,
		"h": 2.9169328337
	},
	{
		"x": -116.4088593067,
		"y": -0.704440279,
		"ID": 108,
		"h": 2.3520092311
	},
	{
		"x": -116.4088593067,
		"y": 5.069065104,
		"ID": 109,
		"h": 3.2596133611
	},
	{
		"x": -116.4088593067,
		"y": 10.842570488,
		"ID": 110,
		"h": 1.4498273619
	},
	{
		"x": -116.4088593067,
		"y": 16.616075872,
		"ID": 111,
		"h": 6.7207966203
	},
	{
		"x": -116.4088593067,
		"y": 22.389581256,
		"ID": 112,
		"h": 2.2260375669
	},
	{
		"x": -116.4088593067,
		"y": 28.163086639,
		"ID": 113,
		"h": 2.4117223479
	},
	{
		"x": -116.4088593067,
		"y": 33.936592023,
		"ID": 114,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -72.873257577,
		"ID": 115,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -67.099752193,
		"ID": 116,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -61.326246809,
		"ID": 117,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -55.552741426,
		"ID": 118,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -49.779236042,
		"ID": 119,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -44.005730658,
		"ID": 120,
		"h": 2.278292221
	},
	{
		"x": -111.4088569757,
		"y": -38.232225274,
		"ID": 121,
		"h": 1
	},
	{
		"x": -111.4088569757,
		"y": -32.45871989,
		"ID": 122,
		"h": 4.7796211946
	},
	{
		"x": -111.4088569757,
		"y": -26.685214507,
		"ID": 123,
		"h": 1.7054463594
	},
	{
		"x": -111.4088569757,
		"y": -20.911709123,
		"ID": 124,
		"h": 4.3238595604
	},
	{
		"x": -111.4088569757,
		"y": -15.138203739,
		"ID": 125,
		"h": 1.9843338902
	},
	{
		"x": -111.4088569757,
		"y": -9.364698355,
		"ID": 126,
		"h": 3.7169806006
	},
	{
		"x": -111.4088569757,
		"y": -3.591192971,
		"ID": 127,
		"h": 2.4263884155
	},
	{
		"x": -111.4088569757,
		"y": 2.182312412,
		"ID": 128,
		"h": 4.4131461976
	},
	{
		"x": -111.4088569757,
		"y": 7.955817796,
		"ID": 129,
		"h": 1.9030514581
	},
	{
		"x": -111.4088569757,
		"y": 13.72932318,
		"ID": 130,
		"h": 4.5000094196
	},
	{
		"x": -111.4088569757,
		"y": 19.502828564,
		"ID": 131,
		"h": 1.7623559291
	},
	{
		"x": -111.4088569757,
		"y": 25.276333948,
		"ID": 132,
		"h": 2.5929399544
	},
	{
		"x": -111.4088569757,
		"y": 31.049839331,
		"ID": 133,
		"h": 6.57905553
	},
	{
		"x": -111.4088569757,
		"y": 36.823344715,
		"ID": 134,
		"h": 1.5541244748
	},
	{
		"x": -106.4088546447,
		"y": -81.533515653,
		"ID": 135,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -75.760010269,
		"ID": 136,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -69.986504885,
		"ID": 137,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -64.212999501,
		"ID": 138,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -58.439494117,
		"ID": 139,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -52.665988734,
		"ID": 140,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -46.89248335,
		"ID": 141,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -41.118977966,
		"ID": 142,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": -35.345472582,
		"ID": 143,
		"h": 10.6743073265
	},
	{
		"x": -106.4088546447,
		"y": -29.571967198,
		"ID": 144,
		"h": 5.6852233346
	},
	{
		"x": -106.4088546447,
		"y": -23.798461815,
		"ID": 145,
		"h": 1.9432066189
	},
	{
		"x": -106.4088546447,
		"y": -18.024956431,
		"ID": 146,
		"h": 4.8654771555
	},
	{
		"x": -106.4088546447,
		"y": -12.251451047,
		"ID": 147,
		"h": 5.4508918076
	},
	{
		"x": -106.4088546447,
		"y": -6.477945663,
		"ID": 148,
		"h": 4.3007073649
	},
	{
		"x": -106.4088546447,
		"y": -0.704440279,
		"ID": 149,
		"h": 2.4935466558
	},
	{
		"x": -106.4088546447,
		"y": 5.069065104,
		"ID": 150,
		"h": 5.8025711819
	},
	{
		"x": -106.4088546447,
		"y": 10.842570488,
		"ID": 151,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": 16.616075872,
		"ID": 152,
		"h": 7.7704686836
	},
	{
		"x": -106.4088546447,
		"y": 22.389581256,
		"ID": 153,
		"h": 1
	},
	{
		"x": -106.4088546447,
		"y": 28.163086639,
		"ID": 154,
		"h": 2.3359571284
	},
	{
		"x": -106.4088546447,
		"y": 33.936592023,
		"ID": 155,
		"h": 13.2983395257
	},
	{
		"x": -106.4088546447,
		"y": 39.710097407,
		"ID": 156,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": -84.4202683445,
		"ID": 157,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": -78.646762961,
		"ID": 158,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": -72.873257577,
		"ID": 159,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": -67.099752193,
		"ID": 160,
		"h": 3.7814679002
	},
	{
		"x": -101.4088523137,
		"y": -61.326246809,
		"ID": 161,
		"h": 4.3931365334
	},
	{
		"x": -101.4088523137,
		"y": -55.552741426,
		"ID": 162,
		"h": 3.4029935247
	},
	{
		"x": -101.4088523137,
		"y": -49.779236042,
		"ID": 163,
		"h": 4.32570709
	},
	{
		"x": -101.4088523137,
		"y": -44.005730658,
		"ID": 164,
		"h": 5.1680303933
	},
	{
		"x": -101.4088523137,
		"y": -38.232225274,
		"ID": 165,
		"h": 13.8868753957
	},
	{
		"x": -101.4088523137,
		"y": -32.45871989,
		"ID": 166,
		"h": 7.9420935628
	},
	{
		"x": -101.4088523137,
		"y": -26.685214507,
		"ID": 167,
		"h": 2.7493087627
	},
	{
		"x": -101.4088523137,
		"y": -20.911709123,
		"ID": 168,
		"h": 2.510804362
	},
	{
		"x": -101.4088523137,
		"y": -15.138203739,
		"ID": 169,
		"h": 3.2211536017
	},
	{
		"x": -101.4088523137,
		"y": -9.364698355,
		"ID": 170,
		"h": 6.2046009938
	},
	{
		"x": -101.4088523137,
		"y": -3.591192971,
		"ID": 171,
		"h": 2.1639046378
	},
	{
		"x": -101.4088523137,
		"y": 2.182312412,
		"ID": 172,
		"h": 4.1364516323
	},
	{
		"x": -101.4088523137,
		"y": 7.955817796,
		"ID": 173,
		"h": 2.9035665582
	},
	{
		"x": -101.4088523137,
		"y": 13.72932318,
		"ID": 174,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": 19.502828564,
		"ID": 175,
		"h": 7.6373473383
	},
	{
		"x": -101.4088523137,
		"y": 25.276333948,
		"ID": 176,
		"h": 8.5507333591
	},
	{
		"x": -101.4088523137,
		"y": 31.049839331,
		"ID": 177,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": 36.823344715,
		"ID": 178,
		"h": 2.2817832369
	},
	{
		"x": -101.4088523137,
		"y": 42.596850099,
		"ID": 179,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": 48.370355483,
		"ID": 180,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": 59.91736625,
		"ID": 181,
		"h": 1
	},
	{
		"x": -101.4088523137,
		"y": 65.690871634,
		"ID": 182,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -93.0805264202,
		"ID": 183,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -87.3070210364,
		"ID": 184,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -81.533515653,
		"ID": 185,
		"h": 1.9378474647
	},
	{
		"x": -96.4088499817,
		"y": -75.760010269,
		"ID": 186,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -69.986504885,
		"ID": 187,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -64.212999501,
		"ID": 188,
		"h": 2.1205904235
	},
	{
		"x": -96.4088499817,
		"y": -58.439494117,
		"ID": 189,
		"h": 10.7385247523
	},
	{
		"x": -96.4088499817,
		"y": -52.665988734,
		"ID": 190,
		"h": 2.3870503458
	},
	{
		"x": -96.4088499817,
		"y": -46.89248335,
		"ID": 191,
		"h": 3.0530868359
	},
	{
		"x": -96.4088499817,
		"y": -41.118977966,
		"ID": 192,
		"h": 2.2660232518
	},
	{
		"x": -96.4088499817,
		"y": -35.345472582,
		"ID": 193,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -29.571967198,
		"ID": 194,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": -23.798461815,
		"ID": 195,
		"h": 2.6927087715
	},
	{
		"x": -96.4088499817,
		"y": -18.024956431,
		"ID": 196,
		"h": 3.8063644759
	},
	{
		"x": -96.4088499817,
		"y": -12.251451047,
		"ID": 197,
		"h": 1.9216459222
	},
	{
		"x": -96.4088499817,
		"y": -6.477945663,
		"ID": 198,
		"h": 3.6234284858
	},
	{
		"x": -96.4088499817,
		"y": -0.704440279,
		"ID": 199,
		"h": 2.6109764134
	},
	{
		"x": -96.4088499817,
		"y": 5.069065104,
		"ID": 200,
		"h": 7.0027909006
	},
	{
		"x": -96.4088499817,
		"y": 10.842570488,
		"ID": 201,
		"h": 2.3804216478
	},
	{
		"x": -96.4088499817,
		"y": 16.616075872,
		"ID": 202,
		"h": 2.424763827
	},
	{
		"x": -96.4088499817,
		"y": 22.389581256,
		"ID": 203,
		"h": 12.709556652
	},
	{
		"x": -96.4088499817,
		"y": 28.163086639,
		"ID": 204,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": 33.936592023,
		"ID": 205,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": 39.710097407,
		"ID": 206,
		"h": 5.1313739351
	},
	{
		"x": -96.4088499817,
		"y": 45.483602791,
		"ID": 207,
		"h": 2.9815518362
	},
	{
		"x": -96.4088499817,
		"y": 51.257108175,
		"ID": 208,
		"h": 3.6718138042
	},
	{
		"x": -96.4088499817,
		"y": 57.030613558,
		"ID": 209,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": 62.804118942,
		"ID": 210,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": 68.577624326,
		"ID": 211,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": 74.35112971,
		"ID": 212,
		"h": 1
	},
	{
		"x": -96.4088499817,
		"y": 80.124635094,
		"ID": 213,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -101.7407844959,
		"ID": 214,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -95.9672791121,
		"ID": 215,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -90.1937737283,
		"ID": 216,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -84.4202683445,
		"ID": 217,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -78.646762961,
		"ID": 218,
		"h": 3.2858030937
	},
	{
		"x": -91.4088476507,
		"y": -72.873257577,
		"ID": 219,
		"h": 4.1904045102
	},
	{
		"x": -91.4088476507,
		"y": -67.099752193,
		"ID": 220,
		"h": 3.5574228729
	},
	{
		"x": -91.4088476507,
		"y": -61.326246809,
		"ID": 221,
		"h": 6.139924709
	},
	{
		"x": -91.4088476507,
		"y": -55.552741426,
		"ID": 222,
		"h": 5.3601532063
	},
	{
		"x": -91.4088476507,
		"y": -49.779236042,
		"ID": 223,
		"h": 3.493620033
	},
	{
		"x": -91.4088476507,
		"y": -44.005730658,
		"ID": 224,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -38.232225274,
		"ID": 225,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -32.45871989,
		"ID": 226,
		"h": 2.7577994375
	},
	{
		"x": -91.4088476507,
		"y": -26.685214507,
		"ID": 227,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": -20.911709123,
		"ID": 228,
		"h": 10.3520922677
	},
	{
		"x": -91.4088476507,
		"y": -15.138203739,
		"ID": 229,
		"h": 3.5990115667
	},
	{
		"x": -91.4088476507,
		"y": -9.364698355,
		"ID": 230,
		"h": 3.9347369988
	},
	{
		"x": -91.4088476507,
		"y": -3.591192971,
		"ID": 231,
		"h": 5.044850845
	},
	{
		"x": -91.4088476507,
		"y": 2.182312412,
		"ID": 232,
		"h": 3.1527568188
	},
	{
		"x": -91.4088476507,
		"y": 7.955817796,
		"ID": 233,
		"h": 5.5449149297
	},
	{
		"x": -91.4088476507,
		"y": 13.72932318,
		"ID": 234,
		"h": 3.5673133793
	},
	{
		"x": -91.4088476507,
		"y": 19.502828564,
		"ID": 235,
		"h": 2.7634447273
	},
	{
		"x": -91.4088476507,
		"y": 25.276333948,
		"ID": 236,
		"h": 5.2230096172
	},
	{
		"x": -91.4088476507,
		"y": 31.049839331,
		"ID": 237,
		"h": 3.1901852805
	},
	{
		"x": -91.4088476507,
		"y": 36.823344715,
		"ID": 238,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": 42.596850099,
		"ID": 239,
		"h": 2.6869068461
	},
	{
		"x": -91.4088476507,
		"y": 48.370355483,
		"ID": 240,
		"h": 2.8261462017
	},
	{
		"x": -91.4088476507,
		"y": 54.143860867,
		"ID": 241,
		"h": 1.8718549244
	},
	{
		"x": -91.4088476507,
		"y": 59.91736625,
		"ID": 242,
		"h": 1
	},
	{
		"x": -91.4088476507,
		"y": 65.690871634,
		"ID": 243,
		"h": 2.8955166841
	},
	{
		"x": -91.4088476507,
		"y": 71.464377018,
		"ID": 244,
		"h": 1.6670944172
	},
	{
		"x": -91.4088476507,
		"y": 77.237882402,
		"ID": 245,
		"h": 2.5694392837
	},
	{
		"x": -86.4088453197,
		"y": -104.6275371878,
		"ID": 246,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -98.854031804,
		"ID": 247,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -93.0805264202,
		"ID": 248,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -87.3070210364,
		"ID": 249,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -81.533515653,
		"ID": 250,
		"h": 2.2483572979
	},
	{
		"x": -86.4088453197,
		"y": -75.760010269,
		"ID": 251,
		"h": 8.6325087831
	},
	{
		"x": -86.4088453197,
		"y": -69.986504885,
		"ID": 252,
		"h": 5.9620231871
	},
	{
		"x": -86.4088453197,
		"y": -64.212999501,
		"ID": 253,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -58.439494117,
		"ID": 254,
		"h": 2.5853844827
	},
	{
		"x": -86.4088453197,
		"y": -52.665988734,
		"ID": 255,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -46.89248335,
		"ID": 256,
		"h": 2.4745671379
	},
	{
		"x": -86.4088453197,
		"y": -41.118977966,
		"ID": 257,
		"h": 1
	},
	{
		"x": -86.4088453197,
		"y": -35.345472582,
		"ID": 258,
		"h": 4.1080344168
	},
	{
		"x": -86.4088453197,
		"y": -29.571967198,
		"ID": 259,
		"h": 2.2007133149
	},
	{
		"x": -86.4088453197,
		"y": -23.798461815,
		"ID": 260,
		"h": 4.9890685123
	},
	{
		"x": -86.4088453197,
		"y": -18.024956431,
		"ID": 261,
		"h": 4.3201624457
	},
	{
		"x": -86.4088453197,
		"y": -12.251451047,
		"ID": 262,
		"h": 2.9454621819
	},
	{
		"x": -86.4088453197,
		"y": -6.477945663,
		"ID": 263,
		"h": 5.8364685397
	},
	{
		"x": -86.4088453197,
		"y": -0.704440279,
		"ID": 264,
		"h": 9.038089923
	},
	{
		"x": -86.4088453197,
		"y": 5.069065104,
		"ID": 265,
		"h": 5.3951413941
	},
	{
		"x": -86.4088453197,
		"y": 10.842570488,
		"ID": 266,
		"h": 4.1056182199
	},
	{
		"x": -86.4088453197,
		"y": 16.616075872,
		"ID": 267,
		"h": 7.0018563232
	},
	{
		"x": -86.4088453197,
		"y": 22.389581256,
		"ID": 268,
		"h": 3.8812040865
	},
	{
		"x": -86.4088453197,
		"y": 28.163086639,
		"ID": 269,
		"h": 5.4925898432
	},
	{
		"x": -86.4088453197,
		"y": 33.936592023,
		"ID": 270,
		"h": 5.1910298082
	},
	{
		"x": -86.4088453197,
		"y": 39.710097407,
		"ID": 271,
		"h": 2.6518114509
	},
	{
		"x": -86.4088453197,
		"y": 45.483602791,
		"ID": 272,
		"h": 4.6954588142
	},
	{
		"x": -86.4088453197,
		"y": 51.257108175,
		"ID": 273,
		"h": 1.9194713725
	},
	{
		"x": -86.4088453197,
		"y": 57.030613558,
		"ID": 274,
		"h": 1.7561746043
	},
	{
		"x": -86.4088453197,
		"y": 62.804118942,
		"ID": 275,
		"h": 2.5929399544
	},
	{
		"x": -86.4088453197,
		"y": 68.577624326,
		"ID": 276,
		"h": 5.9148350206
	},
	{
		"x": -86.4088453197,
		"y": 74.35112971,
		"ID": 277,
		"h": 2.4417609871
	},
	{
		"x": -86.4088453197,
		"y": 80.124635094,
		"ID": 278,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -101.7407844959,
		"ID": 279,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -95.9672791121,
		"ID": 280,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -90.1937737283,
		"ID": 281,
		"h": 2.1592490082
	},
	{
		"x": -81.4088429887,
		"y": -84.4202683445,
		"ID": 282,
		"h": 3.7611295256
	},
	{
		"x": -81.4088429887,
		"y": -78.646762961,
		"ID": 283,
		"h": 3.5897475298
	},
	{
		"x": -81.4088429887,
		"y": -72.873257577,
		"ID": 284,
		"h": 5.4959900769
	},
	{
		"x": -81.4088429887,
		"y": -67.099752193,
		"ID": 285,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -61.326246809,
		"ID": 286,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -55.552741426,
		"ID": 287,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -49.779236042,
		"ID": 288,
		"h": 2.7322444062
	},
	{
		"x": -81.4088429887,
		"y": -44.005730658,
		"ID": 289,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -38.232225274,
		"ID": 290,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -32.45871989,
		"ID": 291,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -26.685214507,
		"ID": 292,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -20.911709123,
		"ID": 293,
		"h": 3.6417767879
	},
	{
		"x": -81.4088429887,
		"y": -15.138203739,
		"ID": 294,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": -9.364698355,
		"ID": 295,
		"h": 2.7085961762
	},
	{
		"x": -81.4088429887,
		"y": -3.591192971,
		"ID": 296,
		"h": 2.9401755941
	},
	{
		"x": -81.4088429887,
		"y": 2.182312412,
		"ID": 297,
		"h": 14.2608256412
	},
	{
		"x": -81.4088429887,
		"y": 7.955817796,
		"ID": 298,
		"h": 4.2540748385
	},
	{
		"x": -81.4088429887,
		"y": 13.72932318,
		"ID": 299,
		"h": 5.3203239553
	},
	{
		"x": -81.4088429887,
		"y": 19.502828564,
		"ID": 300,
		"h": 3.6957884899
	},
	{
		"x": -81.4088429887,
		"y": 25.276333948,
		"ID": 301,
		"h": 3.1217512001
	},
	{
		"x": -81.4088429887,
		"y": 31.049839331,
		"ID": 302,
		"h": 1.9581055023
	},
	{
		"x": -81.4088429887,
		"y": 36.823344715,
		"ID": 303,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": 42.596850099,
		"ID": 304,
		"h": 3.9527703035
	},
	{
		"x": -81.4088429887,
		"y": 48.370355483,
		"ID": 305,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": 54.143860867,
		"ID": 306,
		"h": 2.0692567338
	},
	{
		"x": -81.4088429887,
		"y": 59.91736625,
		"ID": 307,
		"h": 1
	},
	{
		"x": -81.4088429887,
		"y": 65.690871634,
		"ID": 308,
		"h": 3.7866669083
	},
	{
		"x": -81.4088429887,
		"y": 71.464377018,
		"ID": 309,
		"h": 3.2763028054
	},
	{
		"x": -81.4088429887,
		"y": 77.237882402,
		"ID": 310,
		"h": 2.1952403075
	},
	{
		"x": -76.4088406567,
		"y": -98.854031804,
		"ID": 311,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -93.0805264202,
		"ID": 312,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -87.3070210364,
		"ID": 313,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -81.533515653,
		"ID": 314,
		"h": 5.8047396032
	},
	{
		"x": -76.4088406567,
		"y": -75.760010269,
		"ID": 315,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -69.986504885,
		"ID": 316,
		"h": 6.2513965072
	},
	{
		"x": -76.4088406567,
		"y": -64.212999501,
		"ID": 317,
		"h": 3.9542697638
	},
	{
		"x": -76.4088406567,
		"y": -58.439494117,
		"ID": 318,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -52.665988734,
		"ID": 319,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -46.89248335,
		"ID": 320,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -41.118977966,
		"ID": 321,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -35.345472582,
		"ID": 322,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -29.571967198,
		"ID": 323,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -23.798461815,
		"ID": 324,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -18.024956431,
		"ID": 325,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -12.251451047,
		"ID": 326,
		"h": 1
	},
	{
		"x": -76.4088406567,
		"y": -6.477945663,
		"ID": 327,
		"h": 4.635298472
	},
	{
		"x": -76.4088406567,
		"y": -0.704440279,
		"ID": 328,
		"h": 4.6950283422
	},
	{
		"x": -76.4088406567,
		"y": 5.069065104,
		"ID": 329,
		"h": 6.8065745987
	},
	{
		"x": -76.4088406567,
		"y": 10.842570488,
		"ID": 330,
		"h": 5.5916291859
	},
	{
		"x": -76.4088406567,
		"y": 16.616075872,
		"ID": 331,
		"h": 3.2054020537
	},
	{
		"x": -76.4088406567,
		"y": 22.389581256,
		"ID": 332,
		"h": 5.7554272194
	},
	{
		"x": -76.4088406567,
		"y": 28.163086639,
		"ID": 333,
		"h": 4.6326866983
	},
	{
		"x": -76.4088406567,
		"y": 33.936592023,
		"ID": 334,
		"h": 6.2343501816
	},
	{
		"x": -76.4088406567,
		"y": 39.710097407,
		"ID": 335,
		"h": 17.7027475362
	},
	{
		"x": -76.4088406567,
		"y": 45.483602791,
		"ID": 336,
		"h": 3.9527703035
	},
	{
		"x": -76.4088406567,
		"y": 51.257108175,
		"ID": 337,
		"h": 3.8592981207
	},
	{
		"x": -76.4088406567,
		"y": 57.030613558,
		"ID": 338,
		"h": 5.3597676818
	},
	{
		"x": -76.4088406567,
		"y": 62.804118942,
		"ID": 339,
		"h": 2.2904831823
	},
	{
		"x": -76.4088406567,
		"y": 68.577624326,
		"ID": 340,
		"h": 1.621578226
	},
	{
		"x": -71.4088383257,
		"y": -95.9672791121,
		"ID": 341,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -90.1937737283,
		"ID": 342,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -84.4202683445,
		"ID": 343,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -78.646762961,
		"ID": 344,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -72.873257577,
		"ID": 345,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -67.099752193,
		"ID": 346,
		"h": 5.0876613291
	},
	{
		"x": -71.4088383257,
		"y": -61.326246809,
		"ID": 347,
		"h": 7.7957366783
	},
	{
		"x": -71.4088383257,
		"y": -55.552741426,
		"ID": 348,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -49.779236042,
		"ID": 349,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -44.005730658,
		"ID": 350,
		"h": 2.3545321607
	},
	{
		"x": -71.4088383257,
		"y": -38.232225274,
		"ID": 351,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -32.45871989,
		"ID": 352,
		"h": 5.3663185105
	},
	{
		"x": -71.4088383257,
		"y": -26.685214507,
		"ID": 353,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -20.911709123,
		"ID": 354,
		"h": 2.0722059588
	},
	{
		"x": -71.4088383257,
		"y": -15.138203739,
		"ID": 355,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -9.364698355,
		"ID": 356,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": -3.591192971,
		"ID": 357,
		"h": 4.2503250036
	},
	{
		"x": -71.4088383257,
		"y": 2.182312412,
		"ID": 358,
		"h": 4.7931743219
	},
	{
		"x": -71.4088383257,
		"y": 7.955817796,
		"ID": 359,
		"h": 7.0521855748
	},
	{
		"x": -71.4088383257,
		"y": 13.72932318,
		"ID": 360,
		"h": 4.6894291599
	},
	{
		"x": -71.4088383257,
		"y": 19.502828564,
		"ID": 361,
		"h": 3.5815549947
	},
	{
		"x": -71.4088383257,
		"y": 25.276333948,
		"ID": 362,
		"h": 6.0534180121
	},
	{
		"x": -71.4088383257,
		"y": 31.049839331,
		"ID": 363,
		"h": 8.7100139204
	},
	{
		"x": -71.4088383257,
		"y": 36.823344715,
		"ID": 364,
		"h": 10.7966193493
	},
	{
		"x": -71.4088383257,
		"y": 42.596850099,
		"ID": 365,
		"h": 1
	},
	{
		"x": -71.4088383257,
		"y": 48.370355483,
		"ID": 366,
		"h": 1.6300161683
	},
	{
		"x": -71.4088383257,
		"y": 54.143860867,
		"ID": 367,
		"h": 1.4619861566
	},
	{
		"x": -71.4088383257,
		"y": 59.91736625,
		"ID": 368,
		"h": 4.144607822
	},
	{
		"x": -71.4088383257,
		"y": 65.690871634,
		"ID": 369,
		"h": 1.746213759
	},
	{
		"x": -71.4088383257,
		"y": 71.464377018,
		"ID": 370,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -98.854031804,
		"ID": 371,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -93.0805264202,
		"ID": 372,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -87.3070210364,
		"ID": 373,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -81.533515653,
		"ID": 374,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -75.760010269,
		"ID": 375,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -69.986504885,
		"ID": 376,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -64.212999501,
		"ID": 377,
		"h": 13.0592591171
	},
	{
		"x": -66.4088359947,
		"y": -58.439494117,
		"ID": 378,
		"h": 7.0388538494
	},
	{
		"x": -66.4088359947,
		"y": -52.665988734,
		"ID": 379,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -46.89248335,
		"ID": 380,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -41.118977966,
		"ID": 381,
		"h": 2.2314188737
	},
	{
		"x": -66.4088359947,
		"y": -35.345472582,
		"ID": 382,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -29.571967198,
		"ID": 383,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -23.798461815,
		"ID": 384,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -18.024956431,
		"ID": 385,
		"h": 2.5959554599
	},
	{
		"x": -66.4088359947,
		"y": -12.251451047,
		"ID": 386,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -6.477945663,
		"ID": 387,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": -0.704440279,
		"ID": 388,
		"h": 5.9159027408
	},
	{
		"x": -66.4088359947,
		"y": 5.069065104,
		"ID": 389,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": 10.842570488,
		"ID": 390,
		"h": 1
	},
	{
		"x": -66.4088359947,
		"y": 16.616075872,
		"ID": 391,
		"h": 2.5356745598
	},
	{
		"x": -66.4088359947,
		"y": 22.389581256,
		"ID": 392,
		"h": 6.9132532184
	},
	{
		"x": -66.4088359947,
		"y": 28.163086639,
		"ID": 393,
		"h": 5.2993445203
	},
	{
		"x": -66.4088359947,
		"y": 33.936592023,
		"ID": 394,
		"h": 3.8063644759
	},
	{
		"x": -66.4088359947,
		"y": 39.710097407,
		"ID": 395,
		"h": 6.7387909517
	},
	{
		"x": -66.4088359947,
		"y": 45.483602791,
		"ID": 396,
		"h": 4.6695709979
	},
	{
		"x": -66.4088359947,
		"y": 51.257108175,
		"ID": 397,
		"h": 6.269765203
	},
	{
		"x": -66.4088359947,
		"y": 57.030613558,
		"ID": 398,
		"h": 1.6411509854
	},
	{
		"x": -66.4088359947,
		"y": 62.804118942,
		"ID": 399,
		"h": 9.03552553
	},
	{
		"x": -66.4088359947,
		"y": 68.577624326,
		"ID": 400,
		"h": 2.6598977839
	},
	{
		"x": -61.4088336637,
		"y": -95.9672791121,
		"ID": 401,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -90.1937737283,
		"ID": 402,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -84.4202683445,
		"ID": 403,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -78.646762961,
		"ID": 404,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -72.873257577,
		"ID": 405,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -67.099752193,
		"ID": 406,
		"h": 4.1374119175
	},
	{
		"x": -61.4088336637,
		"y": -61.326246809,
		"ID": 407,
		"h": 3.248241434
	},
	{
		"x": -61.4088336637,
		"y": -55.552741426,
		"ID": 408,
		"h": 4.3721328773
	},
	{
		"x": -61.4088336637,
		"y": -49.779236042,
		"ID": 409,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -44.005730658,
		"ID": 410,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -38.232225274,
		"ID": 411,
		"h": 3.311205744
	},
	{
		"x": -61.4088336637,
		"y": -32.45871989,
		"ID": 412,
		"h": 2.6281359118
	},
	{
		"x": -61.4088336637,
		"y": -26.685214507,
		"ID": 413,
		"h": 3.6439298255
	},
	{
		"x": -61.4088336637,
		"y": -20.911709123,
		"ID": 414,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -15.138203739,
		"ID": 415,
		"h": 2.2116097617
	},
	{
		"x": -61.4088336637,
		"y": -9.364698355,
		"ID": 416,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": -3.591192971,
		"ID": 417,
		"h": 2.8247684979
	},
	{
		"x": -61.4088336637,
		"y": 2.182312412,
		"ID": 418,
		"h": 2.9546907434
	},
	{
		"x": -61.4088336637,
		"y": 7.955817796,
		"ID": 419,
		"h": 2.2817832369
	},
	{
		"x": -61.4088336637,
		"y": 13.72932318,
		"ID": 420,
		"h": 13.5644640419
	},
	{
		"x": -61.4088336637,
		"y": 19.502828564,
		"ID": 421,
		"h": 4.3229355389
	},
	{
		"x": -61.4088336637,
		"y": 25.276333948,
		"ID": 422,
		"h": 7.3949146611
	},
	{
		"x": -61.4088336637,
		"y": 31.049839331,
		"ID": 423,
		"h": 3.6696757828
	},
	{
		"x": -61.4088336637,
		"y": 36.823344715,
		"ID": 424,
		"h": 3.3949554636
	},
	{
		"x": -61.4088336637,
		"y": 42.596850099,
		"ID": 425,
		"h": 8.9498170673
	},
	{
		"x": -61.4088336637,
		"y": 48.370355483,
		"ID": 426,
		"h": 1
	},
	{
		"x": -61.4088336637,
		"y": 54.143860867,
		"ID": 427,
		"h": 2.9599511861
	},
	{
		"x": -61.4088336637,
		"y": 59.91736625,
		"ID": 428,
		"h": 1.7927760985
	},
	{
		"x": -61.4088336637,
		"y": 65.690871634,
		"ID": 429,
		"h": 2.5123667246
	},
	{
		"x": -61.4088336637,
		"y": 71.464377018,
		"ID": 430,
		"h": 2.7613291573
	},
	{
		"x": -61.4088336637,
		"y": 77.237882402,
		"ID": 431,
		"h": 4.5448976162
	},
	{
		"x": -56.4088313317,
		"y": -93.0805264202,
		"ID": 432,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -87.3070210364,
		"ID": 433,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -81.533515653,
		"ID": 434,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -75.760010269,
		"ID": 435,
		"h": 2.889464292
	},
	{
		"x": -56.4088313317,
		"y": -69.986504885,
		"ID": 436,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -64.212999501,
		"ID": 437,
		"h": 2.395306641
	},
	{
		"x": -56.4088313317,
		"y": -58.439494117,
		"ID": 438,
		"h": 6.0875818026
	},
	{
		"x": -56.4088313317,
		"y": -52.665988734,
		"ID": 439,
		"h": 4.1398117739
	},
	{
		"x": -56.4088313317,
		"y": -46.89248335,
		"ID": 440,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -41.118977966,
		"ID": 441,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -35.345472582,
		"ID": 442,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -29.571967198,
		"ID": 443,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -23.798461815,
		"ID": 444,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -18.024956431,
		"ID": 445,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -12.251451047,
		"ID": 446,
		"h": 2.2314188737
	},
	{
		"x": -56.4088313317,
		"y": -6.477945663,
		"ID": 447,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": -0.704440279,
		"ID": 448,
		"h": 5.1469394585
	},
	{
		"x": -56.4088313317,
		"y": 5.069065104,
		"ID": 449,
		"h": 4.6235356136
	},
	{
		"x": -56.4088313317,
		"y": 10.842570488,
		"ID": 450,
		"h": 8.4933794185
	},
	{
		"x": -56.4088313317,
		"y": 16.616075872,
		"ID": 451,
		"h": 29.5415670838
	},
	{
		"x": -56.4088313317,
		"y": 22.389581256,
		"ID": 452,
		"h": 13.1122044534
	},
	{
		"x": -56.4088313317,
		"y": 28.163086639,
		"ID": 453,
		"h": 7.0428864387
	},
	{
		"x": -56.4088313317,
		"y": 33.936592023,
		"ID": 454,
		"h": 2.8685174095
	},
	{
		"x": -56.4088313317,
		"y": 39.710097407,
		"ID": 455,
		"h": 3.7986001633
	},
	{
		"x": -56.4088313317,
		"y": 45.483602791,
		"ID": 456,
		"h": 6.7685915968
	},
	{
		"x": -56.4088313317,
		"y": 51.257108175,
		"ID": 457,
		"h": 1.3345108036
	},
	{
		"x": -56.4088313317,
		"y": 57.030613558,
		"ID": 458,
		"h": 1
	},
	{
		"x": -56.4088313317,
		"y": 62.804118942,
		"ID": 459,
		"h": 4.7485811321
	},
	{
		"x": -56.4088313317,
		"y": 68.577624326,
		"ID": 460,
		"h": 6.0663346294
	},
	{
		"x": -56.4088313317,
		"y": 74.35112971,
		"ID": 461,
		"h": 5.081218569
	},
	{
		"x": -56.4088313317,
		"y": 80.124635094,
		"ID": 462,
		"h": 2.667226272
	},
	{
		"x": -56.4088313317,
		"y": 85.898140477,
		"ID": 463,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -90.1937737283,
		"ID": 464,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -84.4202683445,
		"ID": 465,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -78.646762961,
		"ID": 466,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -72.873257577,
		"ID": 467,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -67.099752193,
		"ID": 468,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -61.326246809,
		"ID": 469,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -55.552741426,
		"ID": 470,
		"h": 9.8485857491
	},
	{
		"x": -51.4088290007,
		"y": -49.779236042,
		"ID": 471,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -44.005730658,
		"ID": 472,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -38.232225274,
		"ID": 473,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -32.45871989,
		"ID": 474,
		"h": 3.870519748
	},
	{
		"x": -51.4088290007,
		"y": -26.685214507,
		"ID": 475,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -20.911709123,
		"ID": 476,
		"h": 1
	},
	{
		"x": -51.4088290007,
		"y": -15.138203739,
		"ID": 477,
		"h": 4.0915794791
	},
	{
		"x": -51.4088290007,
		"y": -9.364698355,
		"ID": 478,
		"h": 2.5625724904
	},
	{
		"x": -51.4088290007,
		"y": -3.591192971,
		"ID": 479,
		"h": 7.728118797
	},
	{
		"x": -51.4088290007,
		"y": 2.182312412,
		"ID": 480,
		"h": 4.2983861922
	},
	{
		"x": -51.4088290007,
		"y": 7.955817796,
		"ID": 481,
		"h": 8.5261122363
	},
	{
		"x": -51.4088290007,
		"y": 13.72932318,
		"ID": 482,
		"h": 7.9276640638
	},
	{
		"x": -51.4088290007,
		"y": 19.502828564,
		"ID": 483,
		"h": 5.9247944057
	},
	{
		"x": -51.4088290007,
		"y": 25.276333948,
		"ID": 484,
		"h": 5.2080269209
	},
	{
		"x": -51.4088290007,
		"y": 31.049839331,
		"ID": 485,
		"h": 4.7978257574
	},
	{
		"x": -51.4088290007,
		"y": 36.823344715,
		"ID": 486,
		"h": 5.8727145419
	},
	{
		"x": -51.4088290007,
		"y": 42.596850099,
		"ID": 487,
		"h": 10.4290684779
	},
	{
		"x": -51.4088290007,
		"y": 48.370355483,
		"ID": 488,
		"h": 11.123569603
	},
	{
		"x": -51.4088290007,
		"y": 54.143860867,
		"ID": 489,
		"h": 2.5123667246
	},
	{
		"x": -51.4088290007,
		"y": 59.91736625,
		"ID": 490,
		"h": 1.1880680134
	},
	{
		"x": -51.4088290007,
		"y": 65.690871634,
		"ID": 491,
		"h": 5.8235053403
	},
	{
		"x": -51.4088290007,
		"y": 71.464377018,
		"ID": 492,
		"h": 4.6117472433
	},
	{
		"x": -51.4088290007,
		"y": 77.237882402,
		"ID": 493,
		"h": 12.0300892503
	},
	{
		"x": -51.4088290007,
		"y": 83.011387786,
		"ID": 494,
		"h": 34.8494081257
	},
	{
		"x": -51.4088290007,
		"y": 88.784893169,
		"ID": 495,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -93.0805264202,
		"ID": 496,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -87.3070210364,
		"ID": 497,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -81.533515653,
		"ID": 498,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -75.760010269,
		"ID": 499,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -69.986504885,
		"ID": 500,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -64.212999501,
		"ID": 501,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -58.439494117,
		"ID": 502,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -52.665988734,
		"ID": 503,
		"h": 4.5453401568
	},
	{
		"x": -46.4088266697,
		"y": -46.89248335,
		"ID": 504,
		"h": 2.7336707089
	},
	{
		"x": -46.4088266697,
		"y": -41.118977966,
		"ID": 505,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -35.345472582,
		"ID": 506,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -29.571967198,
		"ID": 507,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -23.798461815,
		"ID": 508,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -18.024956431,
		"ID": 509,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": -12.251451047,
		"ID": 510,
		"h": 3.870519748
	},
	{
		"x": -46.4088266697,
		"y": -6.477945663,
		"ID": 511,
		"h": 14.3224370044
	},
	{
		"x": -46.4088266697,
		"y": -0.704440279,
		"ID": 512,
		"h": 10.304028642
	},
	{
		"x": -46.4088266697,
		"y": 5.069065104,
		"ID": 513,
		"h": 4.8344815571
	},
	{
		"x": -46.4088266697,
		"y": 10.842570488,
		"ID": 514,
		"h": 6.8990828117
	},
	{
		"x": -46.4088266697,
		"y": 16.616075872,
		"ID": 515,
		"h": 3.8969281144
	},
	{
		"x": -46.4088266697,
		"y": 22.389581256,
		"ID": 516,
		"h": 1
	},
	{
		"x": -46.4088266697,
		"y": 28.163086639,
		"ID": 517,
		"h": 9.0749569207
	},
	{
		"x": -46.4088266697,
		"y": 33.936592023,
		"ID": 518,
		"h": 5.7445035649
	},
	{
		"x": -46.4088266697,
		"y": 39.710097407,
		"ID": 519,
		"h": 5.9962507665
	},
	{
		"x": -46.4088266697,
		"y": 45.483602791,
		"ID": 520,
		"h": 8.4686324779
	},
	{
		"x": -46.4088266697,
		"y": 51.257108175,
		"ID": 521,
		"h": 5.0403909532
	},
	{
		"x": -46.4088266697,
		"y": 57.030613558,
		"ID": 522,
		"h": 6.6172379551
	},
	{
		"x": -46.4088266697,
		"y": 62.804118942,
		"ID": 523,
		"h": 1.6229898355
	},
	{
		"x": -46.4088266697,
		"y": 68.577624326,
		"ID": 524,
		"h": 3.8913551472
	},
	{
		"x": -46.4088266697,
		"y": 74.35112971,
		"ID": 525,
		"h": 10.1567174595
	},
	{
		"x": -46.4088266697,
		"y": 80.124635094,
		"ID": 526,
		"h": 16.5376039939
	},
	{
		"x": -46.4088266697,
		"y": 85.898140477,
		"ID": 527,
		"h": 11.7120250313
	},
	{
		"x": -46.4088266697,
		"y": 91.671645861,
		"ID": 528,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -95.9672791121,
		"ID": 529,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -90.1937737283,
		"ID": 530,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -84.4202683445,
		"ID": 531,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -78.646762961,
		"ID": 532,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -72.873257577,
		"ID": 533,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -67.099752193,
		"ID": 534,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -61.326246809,
		"ID": 535,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -55.552741426,
		"ID": 536,
		"h": 3.2035797419
	},
	{
		"x": -41.4088243387,
		"y": -49.779236042,
		"ID": 537,
		"h": 1.8153842053
	},
	{
		"x": -41.4088243387,
		"y": -44.005730658,
		"ID": 538,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -38.232225274,
		"ID": 539,
		"h": 1
	},
	{
		"x": -41.4088243387,
		"y": -32.45871989,
		"ID": 540,
		"h": 2.5967087429
	},
	{
		"x": -41.4088243387,
		"y": -26.685214507,
		"ID": 541,
		"h": 5.6369187643
	},
	{
		"x": -41.4088243387,
		"y": -20.911709123,
		"ID": 542,
		"h": 3.9312219421
	},
	{
		"x": -41.4088243387,
		"y": -15.138203739,
		"ID": 543,
		"h": 3.2078302425
	},
	{
		"x": -41.4088243387,
		"y": -9.364698355,
		"ID": 544,
		"h": 10.1362503364
	},
	{
		"x": -41.4088243387,
		"y": -3.591192971,
		"ID": 545,
		"h": 2.4522163823
	},
	{
		"x": -41.4088243387,
		"y": 2.182312412,
		"ID": 546,
		"h": 3.7923783588
	},
	{
		"x": -41.4088243387,
		"y": 7.955817796,
		"ID": 547,
		"h": 1.6857876659
	},
	{
		"x": -41.4088243387,
		"y": 13.72932318,
		"ID": 548,
		"h": 4.4511310296
	},
	{
		"x": -41.4088243387,
		"y": 19.502828564,
		"ID": 549,
		"h": 2.0294002984
	},
	{
		"x": -41.4088243387,
		"y": 25.276333948,
		"ID": 550,
		"h": 6.6471406335
	},
	{
		"x": -41.4088243387,
		"y": 31.049839331,
		"ID": 551,
		"h": 2.8185602275
	},
	{
		"x": -41.4088243387,
		"y": 36.823344715,
		"ID": 552,
		"h": 3.4343997742
	},
	{
		"x": -41.4088243387,
		"y": 42.596850099,
		"ID": 553,
		"h": 7.6795002442
	},
	{
		"x": -41.4088243387,
		"y": 48.370355483,
		"ID": 554,
		"h": 4.4457217313
	},
	{
		"x": -41.4088243387,
		"y": 54.143860867,
		"ID": 555,
		"h": 5.1779542835
	},
	{
		"x": -41.4088243387,
		"y": 59.91736625,
		"ID": 556,
		"h": 5.9329652952
	},
	{
		"x": -41.4088243387,
		"y": 65.690871634,
		"ID": 557,
		"h": 3.5744407523
	},
	{
		"x": -41.4088243387,
		"y": 71.464377018,
		"ID": 558,
		"h": 5.2111841253
	},
	{
		"x": -41.4088243387,
		"y": 77.237882402,
		"ID": 559,
		"h": 2.2861381137
	},
	{
		"x": -41.4088243387,
		"y": 83.011387786,
		"ID": 560,
		"h": 8.4538119719
	},
	{
		"x": -41.4088243387,
		"y": 88.784893169,
		"ID": 561,
		"h": 2.4441782476
	},
	{
		"x": -36.4088220067,
		"y": -98.854031804,
		"ID": 562,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -93.0805264202,
		"ID": 563,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -87.3070210364,
		"ID": 564,
		"h": 4.9443128042
	},
	{
		"x": -36.4088220067,
		"y": -81.533515653,
		"ID": 565,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -75.760010269,
		"ID": 566,
		"h": 3.5070246477
	},
	{
		"x": -36.4088220067,
		"y": -69.986504885,
		"ID": 567,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -64.212999501,
		"ID": 568,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -58.439494117,
		"ID": 569,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -52.665988734,
		"ID": 570,
		"h": 3.901482504
	},
	{
		"x": -36.4088220067,
		"y": -46.89248335,
		"ID": 571,
		"h": 1.5928807263
	},
	{
		"x": -36.4088220067,
		"y": -41.118977966,
		"ID": 572,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -35.345472582,
		"ID": 573,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -29.571967198,
		"ID": 574,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -23.798461815,
		"ID": 575,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -18.024956431,
		"ID": 576,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -12.251451047,
		"ID": 577,
		"h": 2.4336838571
	},
	{
		"x": -36.4088220067,
		"y": -6.477945663,
		"ID": 578,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": -0.704440279,
		"ID": 579,
		"h": 2.5279316337
	},
	{
		"x": -36.4088220067,
		"y": 5.069065104,
		"ID": 580,
		"h": 2.7057148999
	},
	{
		"x": -36.4088220067,
		"y": 10.842570488,
		"ID": 581,
		"h": 1
	},
	{
		"x": -36.4088220067,
		"y": 16.616075872,
		"ID": 582,
		"h": 3.4689192486
	},
	{
		"x": -36.4088220067,
		"y": 22.389581256,
		"ID": 583,
		"h": 3.2727333773
	},
	{
		"x": -36.4088220067,
		"y": 28.163086639,
		"ID": 584,
		"h": 5.4421401915
	},
	{
		"x": -36.4088220067,
		"y": 33.936592023,
		"ID": 585,
		"h": 2.1629745061
	},
	{
		"x": -36.4088220067,
		"y": 39.710097407,
		"ID": 586,
		"h": 3.7233167657
	},
	{
		"x": -36.4088220067,
		"y": 45.483602791,
		"ID": 587,
		"h": 4.1220237491
	},
	{
		"x": -36.4088220067,
		"y": 51.257108175,
		"ID": 588,
		"h": 5.5449149297
	},
	{
		"x": -36.4088220067,
		"y": 57.030613558,
		"ID": 589,
		"h": 6.5094224652
	},
	{
		"x": -36.4088220067,
		"y": 62.804118942,
		"ID": 590,
		"h": 3.1669197831
	},
	{
		"x": -36.4088220067,
		"y": 68.577624326,
		"ID": 591,
		"h": 6.0306731886
	},
	{
		"x": -36.4088220067,
		"y": 74.35112971,
		"ID": 592,
		"h": 11.017444463
	},
	{
		"x": -36.4088220067,
		"y": 80.124635094,
		"ID": 593,
		"h": 9.0419354903
	},
	{
		"x": -36.4088220067,
		"y": 85.898140477,
		"ID": 594,
		"h": 7.4339573247
	},
	{
		"x": -31.4088196757,
		"y": -95.9672791121,
		"ID": 595,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -90.1937737283,
		"ID": 596,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -84.4202683445,
		"ID": 597,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -78.646762961,
		"ID": 598,
		"h": 2.5541523215
	},
	{
		"x": -31.4088196757,
		"y": -72.873257577,
		"ID": 599,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -67.099752193,
		"ID": 600,
		"h": 4.1239500326
	},
	{
		"x": -31.4088196757,
		"y": -61.326246809,
		"ID": 601,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -55.552741426,
		"ID": 602,
		"h": 4.2456336502
	},
	{
		"x": -31.4088196757,
		"y": -49.779236042,
		"ID": 603,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -44.005730658,
		"ID": 604,
		"h": 2.5449318574
	},
	{
		"x": -31.4088196757,
		"y": -38.232225274,
		"ID": 605,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -32.45871989,
		"ID": 606,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -26.685214507,
		"ID": 607,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -20.911709123,
		"ID": 608,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": -15.138203739,
		"ID": 609,
		"h": 2.7655586066
	},
	{
		"x": -31.4088196757,
		"y": -9.364698355,
		"ID": 610,
		"h": 2.5006226153
	},
	{
		"x": -31.4088196757,
		"y": -3.591192971,
		"ID": 611,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": 2.182312412,
		"ID": 612,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": 7.955817796,
		"ID": 613,
		"h": 3.3294043809
	},
	{
		"x": -31.4088196757,
		"y": 13.72932318,
		"ID": 614,
		"h": 7.4160948485
	},
	{
		"x": -31.4088196757,
		"y": 19.502828564,
		"ID": 615,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": 25.276333948,
		"ID": 616,
		"h": 1
	},
	{
		"x": -31.4088196757,
		"y": 31.049839331,
		"ID": 617,
		"h": 3.2126812874
	},
	{
		"x": -31.4088196757,
		"y": 36.823344715,
		"ID": 618,
		"h": 2.2527893439
	},
	{
		"x": -31.4088196757,
		"y": 42.596850099,
		"ID": 619,
		"h": 5.7830259263
	},
	{
		"x": -31.4088196757,
		"y": 48.370355483,
		"ID": 620,
		"h": 9.0902850833
	},
	{
		"x": -31.4088196757,
		"y": 54.143860867,
		"ID": 621,
		"h": 6.581344843
	},
	{
		"x": -31.4088196757,
		"y": 59.91736625,
		"ID": 622,
		"h": 7.8486537966
	},
	{
		"x": -31.4088196757,
		"y": 65.690871634,
		"ID": 623,
		"h": 1.9421364145
	},
	{
		"x": -31.4088196757,
		"y": 71.464377018,
		"ID": 624,
		"h": 7.8819800027
	},
	{
		"x": -31.4088196757,
		"y": 77.237882402,
		"ID": 625,
		"h": 3.4224403438
	},
	{
		"x": -31.4088196757,
		"y": 83.011387786,
		"ID": 626,
		"h": 4.1350108368
	},
	{
		"x": -31.4088196757,
		"y": 88.784893169,
		"ID": 627,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -98.854031804,
		"ID": 628,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -93.0805264202,
		"ID": 629,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -87.3070210364,
		"ID": 630,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -81.533515653,
		"ID": 631,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -75.760010269,
		"ID": 632,
		"h": 1.849108559
	},
	{
		"x": -26.4088173447,
		"y": -69.986504885,
		"ID": 633,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -64.212999501,
		"ID": 634,
		"h": 3.2715427372
	},
	{
		"x": -26.4088173447,
		"y": -58.439494117,
		"ID": 635,
		"h": 6.2138456075
	},
	{
		"x": -26.4088173447,
		"y": -52.665988734,
		"ID": 636,
		"h": 3.2596133611
	},
	{
		"x": -26.4088173447,
		"y": -46.89248335,
		"ID": 637,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -41.118977966,
		"ID": 638,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -35.345472582,
		"ID": 639,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -29.571967198,
		"ID": 640,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -23.798461815,
		"ID": 641,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": -18.024956431,
		"ID": 642,
		"h": 2.1470855827
	},
	{
		"x": -26.4088173447,
		"y": -12.251451047,
		"ID": 643,
		"h": 10.0023417062
	},
	{
		"x": -26.4088173447,
		"y": -6.477945663,
		"ID": 644,
		"h": 2.0524407894
	},
	{
		"x": -26.4088173447,
		"y": -0.704440279,
		"ID": 645,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": 5.069065104,
		"ID": 646,
		"h": 4.6803723393
	},
	{
		"x": -26.4088173447,
		"y": 10.842570488,
		"ID": 647,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": 16.616075872,
		"ID": 648,
		"h": 2.6221811207
	},
	{
		"x": -26.4088173447,
		"y": 22.389581256,
		"ID": 649,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": 28.163086639,
		"ID": 650,
		"h": 1
	},
	{
		"x": -26.4088173447,
		"y": 33.936592023,
		"ID": 651,
		"h": 5.3897707043
	},
	{
		"x": -26.4088173447,
		"y": 39.710097407,
		"ID": 652,
		"h": 2.7977630725
	},
	{
		"x": -26.4088173447,
		"y": 45.483602791,
		"ID": 653,
		"h": 4.2310616297
	},
	{
		"x": -26.4088173447,
		"y": 51.257108175,
		"ID": 654,
		"h": 3.0178529059
	},
	{
		"x": -26.4088173447,
		"y": 57.030613558,
		"ID": 655,
		"h": 8.5293267302
	},
	{
		"x": -26.4088173447,
		"y": 62.804118942,
		"ID": 656,
		"h": 11.605806074
	},
	{
		"x": -26.4088173447,
		"y": 68.577624326,
		"ID": 657,
		"h": 4.3725904052
	},
	{
		"x": -26.4088173447,
		"y": 74.35112971,
		"ID": 658,
		"h": 6.3643349977
	},
	{
		"x": -26.4088173447,
		"y": 80.124635094,
		"ID": 659,
		"h": 3.6931316678
	},
	{
		"x": -26.4088173447,
		"y": 85.898140477,
		"ID": 660,
		"h": 7.9877964571
	},
	{
		"x": -21.4088150137,
		"y": -90.1937737283,
		"ID": 661,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -84.4202683445,
		"ID": 662,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -78.646762961,
		"ID": 663,
		"h": 3.5226032296
	},
	{
		"x": -21.4088150137,
		"y": -72.873257577,
		"ID": 664,
		"h": 2.6898094689
	},
	{
		"x": -21.4088150137,
		"y": -67.099752193,
		"ID": 665,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -61.326246809,
		"ID": 666,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -55.552741426,
		"ID": 667,
		"h": 2.081021382
	},
	{
		"x": -21.4088150137,
		"y": -49.779236042,
		"ID": 668,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -44.005730658,
		"ID": 669,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -38.232225274,
		"ID": 670,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -32.45871989,
		"ID": 671,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -26.685214507,
		"ID": 672,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": -20.911709123,
		"ID": 673,
		"h": 3.3416788104
	},
	{
		"x": -21.4088150137,
		"y": -15.138203739,
		"ID": 674,
		"h": 1.5525979594
	},
	{
		"x": -21.4088150137,
		"y": -9.364698355,
		"ID": 675,
		"h": 2.174103599
	},
	{
		"x": -21.4088150137,
		"y": -3.591192971,
		"ID": 676,
		"h": 1.8514013839
	},
	{
		"x": -21.4088150137,
		"y": 2.182312412,
		"ID": 677,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": 7.955817796,
		"ID": 678,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": 13.72932318,
		"ID": 679,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": 19.502828564,
		"ID": 680,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": 25.276333948,
		"ID": 681,
		"h": 1
	},
	{
		"x": -21.4088150137,
		"y": 31.049839331,
		"ID": 682,
		"h": 3.7212058036
	},
	{
		"x": -21.4088150137,
		"y": 36.823344715,
		"ID": 683,
		"h": 3.7206778925
	},
	{
		"x": -21.4088150137,
		"y": 42.596850099,
		"ID": 684,
		"h": 5.7928051963
	},
	{
		"x": -21.4088150137,
		"y": 48.370355483,
		"ID": 685,
		"h": 5.3939909004
	},
	{
		"x": -21.4088150137,
		"y": 54.143860867,
		"ID": 686,
		"h": 9.5643814896
	},
	{
		"x": -21.4088150137,
		"y": 59.91736625,
		"ID": 687,
		"h": 9.4165426664
	},
	{
		"x": -21.4088150137,
		"y": 65.690871634,
		"ID": 688,
		"h": 6.1451049251
	},
	{
		"x": -21.4088150137,
		"y": 71.464377018,
		"ID": 689,
		"h": 3.321784274
	},
	{
		"x": -21.4088150137,
		"y": 77.237882402,
		"ID": 690,
		"h": 4.0876992404
	},
	{
		"x": -21.4088150137,
		"y": 83.011387786,
		"ID": 691,
		"h": 5.1644539351
	},
	{
		"x": -16.4088126817,
		"y": -87.3070210364,
		"ID": 692,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -81.533515653,
		"ID": 693,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -75.760010269,
		"ID": 694,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -69.986504885,
		"ID": 695,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -64.212999501,
		"ID": 696,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -58.439494117,
		"ID": 697,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -52.665988734,
		"ID": 698,
		"h": 10.5753911389
	},
	{
		"x": -16.4088126817,
		"y": -46.89248335,
		"ID": 699,
		"h": 1.9096431264
	},
	{
		"x": -16.4088126817,
		"y": -41.118977966,
		"ID": 700,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -35.345472582,
		"ID": 701,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -29.571967198,
		"ID": 702,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -23.798461815,
		"ID": 703,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -18.024956431,
		"ID": 704,
		"h": 4.0354844269
	},
	{
		"x": -16.4088126817,
		"y": -12.251451047,
		"ID": 705,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -6.477945663,
		"ID": 706,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": -0.704440279,
		"ID": 707,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": 5.069065104,
		"ID": 708,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": 10.842570488,
		"ID": 709,
		"h": 2.8569637081
	},
	{
		"x": -16.4088126817,
		"y": 16.616075872,
		"ID": 710,
		"h": 5.5838033888
	},
	{
		"x": -16.4088126817,
		"y": 22.389581256,
		"ID": 711,
		"h": 2.0819979145
	},
	{
		"x": -16.4088126817,
		"y": 28.163086639,
		"ID": 712,
		"h": 1
	},
	{
		"x": -16.4088126817,
		"y": 33.936592023,
		"ID": 713,
		"h": 3.5842877633
	},
	{
		"x": -16.4088126817,
		"y": 39.710097407,
		"ID": 714,
		"h": 5.592746431
	},
	{
		"x": -16.4088126817,
		"y": 45.483602791,
		"ID": 715,
		"h": 7.322669607
	},
	{
		"x": -16.4088126817,
		"y": 51.257108175,
		"ID": 716,
		"h": 2.8908103839
	},
	{
		"x": -16.4088126817,
		"y": 57.030613558,
		"ID": 717,
		"h": 6.9025487829
	},
	{
		"x": -16.4088126817,
		"y": 62.804118942,
		"ID": 718,
		"h": 11.6517792859
	},
	{
		"x": -16.4088126817,
		"y": 68.577624326,
		"ID": 719,
		"h": 7.5103925844
	},
	{
		"x": -16.4088126817,
		"y": 74.35112971,
		"ID": 720,
		"h": 3.3428455662
	},
	{
		"x": -16.4088126817,
		"y": 80.124635094,
		"ID": 721,
		"h": 8.0911615421
	},
	{
		"x": -16.4088126817,
		"y": 85.898140477,
		"ID": 722,
		"h": 2.7887010298
	},
	{
		"x": -11.4088103507,
		"y": -78.646762961,
		"ID": 723,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -72.873257577,
		"ID": 724,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -67.099752193,
		"ID": 725,
		"h": 1.6950078478
	},
	{
		"x": -11.4088103507,
		"y": -61.326246809,
		"ID": 726,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -55.552741426,
		"ID": 727,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -49.779236042,
		"ID": 728,
		"h": 2.1310485567
	},
	{
		"x": -11.4088103507,
		"y": -44.005730658,
		"ID": 729,
		"h": 1.849108559
	},
	{
		"x": -11.4088103507,
		"y": -38.232225274,
		"ID": 730,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -32.45871989,
		"ID": 731,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -26.685214507,
		"ID": 732,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -20.911709123,
		"ID": 733,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -15.138203739,
		"ID": 734,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -9.364698355,
		"ID": 735,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": -3.591192971,
		"ID": 736,
		"h": 4.45383356
	},
	{
		"x": -11.4088103507,
		"y": 2.182312412,
		"ID": 737,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": 7.955817796,
		"ID": 738,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": 13.72932318,
		"ID": 739,
		"h": 1
	},
	{
		"x": -11.4088103507,
		"y": 19.502828564,
		"ID": 740,
		"h": 2.9069139804
	},
	{
		"x": -11.4088103507,
		"y": 25.276333948,
		"ID": 741,
		"h": 2.1508372994
	},
	{
		"x": -11.4088103507,
		"y": 31.049839331,
		"ID": 742,
		"h": 5.1257767688
	},
	{
		"x": -11.4088103507,
		"y": 36.823344715,
		"ID": 743,
		"h": 5.1708106692
	},
	{
		"x": -11.4088103507,
		"y": 42.596850099,
		"ID": 744,
		"h": 3.8969281144
	},
	{
		"x": -11.4088103507,
		"y": 48.370355483,
		"ID": 745,
		"h": 5.6638777289
	},
	{
		"x": -11.4088103507,
		"y": 54.143860867,
		"ID": 746,
		"h": 3.9915929707
	},
	{
		"x": -11.4088103507,
		"y": 59.91736625,
		"ID": 747,
		"h": 4.7719833056
	},
	{
		"x": -11.4088103507,
		"y": 65.690871634,
		"ID": 748,
		"h": 13.1683024969
	},
	{
		"x": -11.4088103507,
		"y": 71.464377018,
		"ID": 749,
		"h": 3.6406998304
	},
	{
		"x": -11.4088103507,
		"y": 77.237882402,
		"ID": 750,
		"h": 4.417682946
	},
	{
		"x": -11.4088103507,
		"y": 83.011387786,
		"ID": 751,
		"h": 3.4315558487
	},
	{
		"x": -11.4088103507,
		"y": 88.784893169,
		"ID": 752,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -75.760010269,
		"ID": 753,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -69.986504885,
		"ID": 754,
		"h": 1.3126806515
	},
	{
		"x": -6.4088080197,
		"y": -64.212999501,
		"ID": 755,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -58.439494117,
		"ID": 756,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -52.665988734,
		"ID": 757,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -46.89248335,
		"ID": 758,
		"h": 1.8329415176
	},
	{
		"x": -6.4088080197,
		"y": -41.118977966,
		"ID": 759,
		"h": 3.1828561486
	},
	{
		"x": -6.4088080197,
		"y": -35.345472582,
		"ID": 760,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -29.571967198,
		"ID": 761,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -23.798461815,
		"ID": 762,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -18.024956431,
		"ID": 763,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -12.251451047,
		"ID": 764,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -6.477945663,
		"ID": 765,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": -0.704440279,
		"ID": 766,
		"h": 3.1613851231
	},
	{
		"x": -6.4088080197,
		"y": 5.069065104,
		"ID": 767,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": 10.842570488,
		"ID": 768,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": 16.616075872,
		"ID": 769,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": 22.389581256,
		"ID": 770,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": 28.163086639,
		"ID": 771,
		"h": 1
	},
	{
		"x": -6.4088080197,
		"y": 33.936592023,
		"ID": 772,
		"h": 5.3346596226
	},
	{
		"x": -6.4088080197,
		"y": 39.710097407,
		"ID": 773,
		"h": 10.7039639443
	},
	{
		"x": -6.4088080197,
		"y": 45.483602791,
		"ID": 774,
		"h": 3.5793673905
	},
	{
		"x": -6.4088080197,
		"y": 51.257108175,
		"ID": 775,
		"h": 5.1866743253
	},
	{
		"x": -6.4088080197,
		"y": 57.030613558,
		"ID": 776,
		"h": 6.6260247235
	},
	{
		"x": -6.4088080197,
		"y": 62.804118942,
		"ID": 777,
		"h": 6.5816718366
	},
	{
		"x": -6.4088080197,
		"y": 68.577624326,
		"ID": 778,
		"h": 9.1015134417
	},
	{
		"x": -6.4088080197,
		"y": 74.35112971,
		"ID": 779,
		"h": 5.3847797098
	},
	{
		"x": -6.4088080197,
		"y": 80.124635094,
		"ID": 780,
		"h": 3.668606344
	},
	{
		"x": -6.4088080197,
		"y": 85.898140477,
		"ID": 781,
		"h": 3.9662472366
	},
	{
		"x": -6.4088080197,
		"y": 91.671645861,
		"ID": 782,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -55.552741426,
		"ID": 783,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -49.779236042,
		"ID": 784,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -44.005730658,
		"ID": 785,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -38.232225274,
		"ID": 786,
		"h": 1.6910663856
	},
	{
		"x": -1.4088056887,
		"y": -32.45871989,
		"ID": 787,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -26.685214507,
		"ID": 788,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -20.911709123,
		"ID": 789,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -15.138203739,
		"ID": 790,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": -9.364698355,
		"ID": 791,
		"h": 5.1493306974
	},
	{
		"x": -1.4088056887,
		"y": -3.591192971,
		"ID": 792,
		"h": 2.472183249
	},
	{
		"x": -1.4088056887,
		"y": 2.182312412,
		"ID": 793,
		"h": 3.9517703813
	},
	{
		"x": -1.4088056887,
		"y": 7.955817796,
		"ID": 794,
		"h": 4.6379089953
	},
	{
		"x": -1.4088056887,
		"y": 13.72932318,
		"ID": 795,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": 19.502828564,
		"ID": 796,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": 25.276333948,
		"ID": 797,
		"h": 5.3993581543
	},
	{
		"x": -1.4088056887,
		"y": 31.049839331,
		"ID": 798,
		"h": 1
	},
	{
		"x": -1.4088056887,
		"y": 36.823344715,
		"ID": 799,
		"h": 5.2755631268
	},
	{
		"x": -1.4088056887,
		"y": 42.596850099,
		"ID": 800,
		"h": 4.0755524806
	},
	{
		"x": -1.4088056887,
		"y": 48.370355483,
		"ID": 801,
		"h": 7.7347566801
	},
	{
		"x": -1.4088056887,
		"y": 54.143860867,
		"ID": 802,
		"h": 8.3508732994
	},
	{
		"x": -1.4088056887,
		"y": 59.91736625,
		"ID": 803,
		"h": 5.2418846305
	},
	{
		"x": -1.4088056887,
		"y": 65.690871634,
		"ID": 804,
		"h": 9.2228332977
	},
	{
		"x": -1.4088056887,
		"y": 71.464377018,
		"ID": 805,
		"h": 8.0515038044
	},
	{
		"x": -1.4088056887,
		"y": 77.237882402,
		"ID": 806,
		"h": 8.8032292861
	},
	{
		"x": -1.4088056887,
		"y": 83.011387786,
		"ID": 807,
		"h": 5.1293755278
	},
	{
		"x": -1.4088056887,
		"y": 88.784893169,
		"ID": 808,
		"h": 4.2835048109
	},
	{
		"x": -1.4088056887,
		"y": 94.558398553,
		"ID": 809,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -46.89248335,
		"ID": 810,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -41.118977966,
		"ID": 811,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -35.345472582,
		"ID": 812,
		"h": 2.2809110777
	},
	{
		"x": 3.5911966433,
		"y": -29.571967198,
		"ID": 813,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -23.798461815,
		"ID": 814,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -18.024956431,
		"ID": 815,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -12.251451047,
		"ID": 816,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -6.477945663,
		"ID": 817,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": -0.704440279,
		"ID": 818,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": 5.069065104,
		"ID": 819,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": 10.842570488,
		"ID": 820,
		"h": 8.2916567784
	},
	{
		"x": 3.5911966433,
		"y": 16.616075872,
		"ID": 821,
		"h": 4.9804719641
	},
	{
		"x": 3.5911966433,
		"y": 22.389581256,
		"ID": 822,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": 28.163086639,
		"ID": 823,
		"h": 23.656499833
	},
	{
		"x": 3.5911966433,
		"y": 33.936592023,
		"ID": 824,
		"h": 1
	},
	{
		"x": 3.5911966433,
		"y": 39.710097407,
		"ID": 825,
		"h": 6.2809695305
	},
	{
		"x": 3.5911966433,
		"y": 45.483602791,
		"ID": 826,
		"h": 4.6669755214
	},
	{
		"x": 3.5911966433,
		"y": 51.257108175,
		"ID": 827,
		"h": 2.7478909789
	},
	{
		"x": 3.5911966433,
		"y": 57.030613558,
		"ID": 828,
		"h": 6.4541542191
	},
	{
		"x": 3.5911966433,
		"y": 62.804118942,
		"ID": 829,
		"h": 10.5484411207
	},
	{
		"x": 3.5911966433,
		"y": 68.577624326,
		"ID": 830,
		"h": 8.4089613323
	},
	{
		"x": 3.5911966433,
		"y": 74.35112971,
		"ID": 831,
		"h": 6.3043457143
	},
	{
		"x": 3.5911966433,
		"y": 80.124635094,
		"ID": 832,
		"h": 10.0801029181
	},
	{
		"x": 3.5911966433,
		"y": 85.898140477,
		"ID": 833,
		"h": 8.2867304144
	},
	{
		"x": 3.5911966433,
		"y": 91.671645861,
		"ID": 834,
		"h": 2.148024278
	},
	{
		"x": 8.5911989743,
		"y": -44.005730658,
		"ID": 835,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": -38.232225274,
		"ID": 836,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": -32.45871989,
		"ID": 837,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": -26.685214507,
		"ID": 838,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": -20.911709123,
		"ID": 839,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": -15.138203739,
		"ID": 840,
		"h": 1.6589754418
	},
	{
		"x": 8.5911989743,
		"y": -9.364698355,
		"ID": 841,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": -3.591192971,
		"ID": 842,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": 2.182312412,
		"ID": 843,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": 7.955817796,
		"ID": 844,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": 13.72932318,
		"ID": 845,
		"h": 1
	},
	{
		"x": 8.5911989743,
		"y": 19.502828564,
		"ID": 846,
		"h": 9.3614670804
	},
	{
		"x": 8.5911989743,
		"y": 25.276333948,
		"ID": 847,
		"h": 7.5560265083
	},
	{
		"x": 8.5911989743,
		"y": 31.049839331,
		"ID": 848,
		"h": 8.8957081277
	},
	{
		"x": 8.5911989743,
		"y": 36.823344715,
		"ID": 849,
		"h": 7.1590625885
	},
	{
		"x": 8.5911989743,
		"y": 42.596850099,
		"ID": 850,
		"h": 5.1277763376
	},
	{
		"x": 8.5911989743,
		"y": 48.370355483,
		"ID": 851,
		"h": 3.7908214634
	},
	{
		"x": 8.5911989743,
		"y": 54.143860867,
		"ID": 852,
		"h": 6.5090926189
	},
	{
		"x": 8.5911989743,
		"y": 59.91736625,
		"ID": 853,
		"h": 9.1927423005
	},
	{
		"x": 8.5911989743,
		"y": 65.690871634,
		"ID": 854,
		"h": 4.9537847638
	},
	{
		"x": 8.5911989743,
		"y": 71.464377018,
		"ID": 855,
		"h": 12.4581379193
	},
	{
		"x": 8.5911989743,
		"y": 77.237882402,
		"ID": 856,
		"h": 11.4080535191
	},
	{
		"x": 8.5911989743,
		"y": 83.011387786,
		"ID": 857,
		"h": 4.674326196
	},
	{
		"x": 8.5911989743,
		"y": 88.784893169,
		"ID": 858,
		"h": 1.6159102693
	},
	{
		"x": 8.5911989743,
		"y": 100.331903937,
		"ID": 859,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -58.439494117,
		"ID": 860,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -52.665988734,
		"ID": 861,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -35.345472582,
		"ID": 862,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -29.571967198,
		"ID": 863,
		"h": 2.0603763191
	},
	{
		"x": 13.5912013053,
		"y": -23.798461815,
		"ID": 864,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -18.024956431,
		"ID": 865,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -12.251451047,
		"ID": 866,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -6.477945663,
		"ID": 867,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": -0.704440279,
		"ID": 868,
		"h": 1
	},
	{
		"x": 13.5912013053,
		"y": 5.069065104,
		"ID": 869,
		"h": 4.1851792687
	},
	{
		"x": 13.5912013053,
		"y": 10.842570488,
		"ID": 870,
		"h": 3.1718315808
	},
	{
		"x": 13.5912013053,
		"y": 16.616075872,
		"ID": 871,
		"h": 2.9553488146
	},
	{
		"x": 13.5912013053,
		"y": 22.389581256,
		"ID": 872,
		"h": 6.4720660842
	},
	{
		"x": 13.5912013053,
		"y": 28.163086639,
		"ID": 873,
		"h": 7.1102448502
	},
	{
		"x": 13.5912013053,
		"y": 33.936592023,
		"ID": 874,
		"h": 5.9365150426
	},
	{
		"x": 13.5912013053,
		"y": 39.710097407,
		"ID": 875,
		"h": 7.8819800027
	},
	{
		"x": 13.5912013053,
		"y": 45.483602791,
		"ID": 876,
		"h": 7.447332514
	},
	{
		"x": 13.5912013053,
		"y": 51.257108175,
		"ID": 877,
		"h": 6.5061234096
	},
	{
		"x": 13.5912013053,
		"y": 57.030613558,
		"ID": 878,
		"h": 6.3619843302
	},
	{
		"x": 13.5912013053,
		"y": 62.804118942,
		"ID": 879,
		"h": 8.0439464212
	},
	{
		"x": 13.5912013053,
		"y": 68.577624326,
		"ID": 880,
		"h": 16.0741056871
	},
	{
		"x": 13.5912013053,
		"y": 74.35112971,
		"ID": 881,
		"h": 8.560086045
	},
	{
		"x": 13.5912013053,
		"y": 80.124635094,
		"ID": 882,
		"h": 5.5475393754
	},
	{
		"x": 13.5912013053,
		"y": 85.898140477,
		"ID": 883,
		"h": 3.3880513554
	},
	{
		"x": 13.5912013053,
		"y": 97.445151245,
		"ID": 884,
		"h": 2.0080589389
	},
	{
		"x": 13.5912013053,
		"y": 103.218656629,
		"ID": 885,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -61.326246809,
		"ID": 886,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -55.552741426,
		"ID": 887,
		"h": 1.2451581033
	},
	{
		"x": 18.5912036363,
		"y": -49.779236042,
		"ID": 888,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -44.005730658,
		"ID": 889,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -38.232225274,
		"ID": 890,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -32.45871989,
		"ID": 891,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -26.685214507,
		"ID": 892,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -20.911709123,
		"ID": 893,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -15.138203739,
		"ID": 894,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -9.364698355,
		"ID": 895,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": -3.591192971,
		"ID": 896,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": 2.182312412,
		"ID": 897,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": 7.955817796,
		"ID": 898,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": 13.72932318,
		"ID": 899,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": 19.502828564,
		"ID": 900,
		"h": 5.2697017286
	},
	{
		"x": 18.5912036363,
		"y": 25.276333948,
		"ID": 901,
		"h": 2.6221811207
	},
	{
		"x": 18.5912036363,
		"y": 31.049839331,
		"ID": 902,
		"h": 7.196955948
	},
	{
		"x": 18.5912036363,
		"y": 36.823344715,
		"ID": 903,
		"h": 2.6473895833
	},
	{
		"x": 18.5912036363,
		"y": 42.596850099,
		"ID": 904,
		"h": 6.3195541149
	},
	{
		"x": 18.5912036363,
		"y": 48.370355483,
		"ID": 905,
		"h": 5.7237022823
	},
	{
		"x": 18.5912036363,
		"y": 54.143860867,
		"ID": 906,
		"h": 8.5931594034
	},
	{
		"x": 18.5912036363,
		"y": 59.91736625,
		"ID": 907,
		"h": 8.1420527718
	},
	{
		"x": 18.5912036363,
		"y": 65.690871634,
		"ID": 908,
		"h": 9.8608458509
	},
	{
		"x": 18.5912036363,
		"y": 71.464377018,
		"ID": 909,
		"h": 10.3743268208
	},
	{
		"x": 18.5912036363,
		"y": 77.237882402,
		"ID": 910,
		"h": 10.7554364881
	},
	{
		"x": 18.5912036363,
		"y": 83.011387786,
		"ID": 911,
		"h": 7.1593688013
	},
	{
		"x": 18.5912036363,
		"y": 88.784893169,
		"ID": 912,
		"h": 3.6444679022
	},
	{
		"x": 18.5912036363,
		"y": 94.558398553,
		"ID": 913,
		"h": 1
	},
	{
		"x": 18.5912036363,
		"y": 100.331903937,
		"ID": 914,
		"h": 5.448609884
	},
	{
		"x": 18.5912036363,
		"y": 106.105409321,
		"ID": 915,
		"h": 2.8746148291
	},
	{
		"x": 18.5912036363,
		"y": 111.878914704,
		"ID": 916,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -64.212999501,
		"ID": 917,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -58.439494117,
		"ID": 918,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -52.665988734,
		"ID": 919,
		"h": 1.3533749592
	},
	{
		"x": 23.5912059683,
		"y": -46.89248335,
		"ID": 920,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -41.118977966,
		"ID": 921,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -35.345472582,
		"ID": 922,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -29.571967198,
		"ID": 923,
		"h": 1.3345108036
	},
	{
		"x": 23.5912059683,
		"y": -23.798461815,
		"ID": 924,
		"h": 1.4266432747
	},
	{
		"x": 23.5912059683,
		"y": -18.024956431,
		"ID": 925,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -12.251451047,
		"ID": 926,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -6.477945663,
		"ID": 927,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": -0.704440279,
		"ID": 928,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": 5.069065104,
		"ID": 929,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": 10.842570488,
		"ID": 930,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": 16.616075872,
		"ID": 931,
		"h": 2.667226272
	},
	{
		"x": 23.5912059683,
		"y": 22.389581256,
		"ID": 932,
		"h": 3.2187351417
	},
	{
		"x": 23.5912059683,
		"y": 28.163086639,
		"ID": 933,
		"h": 6.964393284
	},
	{
		"x": 23.5912059683,
		"y": 33.936592023,
		"ID": 934,
		"h": 3.9552691221
	},
	{
		"x": 23.5912059683,
		"y": 39.710097407,
		"ID": 935,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": 45.483602791,
		"ID": 936,
		"h": 15.7705874851
	},
	{
		"x": 23.5912059683,
		"y": 51.257108175,
		"ID": 937,
		"h": 4.3990566508
	},
	{
		"x": 23.5912059683,
		"y": 57.030613558,
		"ID": 938,
		"h": 16.6276516934
	},
	{
		"x": 23.5912059683,
		"y": 62.804118942,
		"ID": 939,
		"h": 50
	},
	{
		"x": 23.5912059683,
		"y": 68.577624326,
		"ID": 940,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": 74.35112971,
		"ID": 941,
		"h": 7.8412332867
	},
	{
		"x": 23.5912059683,
		"y": 80.124635094,
		"ID": 942,
		"h": 10.0760835344
	},
	{
		"x": 23.5912059683,
		"y": 85.898140477,
		"ID": 943,
		"h": 5.2603123164
	},
	{
		"x": 23.5912059683,
		"y": 91.671645861,
		"ID": 944,
		"h": 4.3247834108
	},
	{
		"x": 23.5912059683,
		"y": 97.445151245,
		"ID": 945,
		"h": 1
	},
	{
		"x": 23.5912059683,
		"y": 103.218656629,
		"ID": 946,
		"h": 3.2199445913
	},
	{
		"x": 23.5912059683,
		"y": 108.992162013,
		"ID": 947,
		"h": 1.8853145629
	},
	{
		"x": 23.5912059683,
		"y": 114.765667396,
		"ID": 948,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": -72.873257577,
		"ID": 949,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": -67.099752193,
		"ID": 950,
		"h": 1.581139825
	},
	{
		"x": 28.5912082993,
		"y": -61.326246809,
		"ID": 951,
		"h": 1.3408760409
	},
	{
		"x": 28.5912082993,
		"y": -55.552741426,
		"ID": 952,
		"h": 1.2262825606
	},
	{
		"x": 28.5912082993,
		"y": -49.779236042,
		"ID": 953,
		"h": 2.4959077879
	},
	{
		"x": 28.5912082993,
		"y": -44.005730658,
		"ID": 954,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": -38.232225274,
		"ID": 955,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": -32.45871989,
		"ID": 956,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": -26.685214507,
		"ID": 957,
		"h": 2.806101088
	},
	{
		"x": 28.5912082993,
		"y": -20.911709123,
		"ID": 958,
		"h": 1.5166714623
	},
	{
		"x": 28.5912082993,
		"y": -15.138203739,
		"ID": 959,
		"h": 2.9586369586
	},
	{
		"x": 28.5912082993,
		"y": -9.364698355,
		"ID": 960,
		"h": 1.8011548464
	},
	{
		"x": 28.5912082993,
		"y": -3.591192971,
		"ID": 961,
		"h": 1.9915945778
	},
	{
		"x": 28.5912082993,
		"y": 2.182312412,
		"ID": 962,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": 7.955817796,
		"ID": 963,
		"h": 3.8791710128
	},
	{
		"x": 28.5912082993,
		"y": 13.72932318,
		"ID": 964,
		"h": 3.4570720062
	},
	{
		"x": 28.5912082993,
		"y": 19.502828564,
		"ID": 965,
		"h": 3.1699905253
	},
	{
		"x": 28.5912082993,
		"y": 25.276333948,
		"ID": 966,
		"h": 6.2853790071
	},
	{
		"x": 28.5912082993,
		"y": 31.049839331,
		"ID": 967,
		"h": 4.2573535825
	},
	{
		"x": 28.5912082993,
		"y": 36.823344715,
		"ID": 968,
		"h": 7.8238025268
	},
	{
		"x": 28.5912082993,
		"y": 42.596850099,
		"ID": 969,
		"h": 4.2498560714
	},
	{
		"x": 28.5912082993,
		"y": 48.370355483,
		"ID": 970,
		"h": 4.3113707772
	},
	{
		"x": 28.5912082993,
		"y": 54.143860867,
		"ID": 971,
		"h": 14.4219702994
	},
	{
		"x": 28.5912082993,
		"y": 59.91736625,
		"ID": 972,
		"h": 12.9798439719
	},
	{
		"x": 28.5912082993,
		"y": 65.690871634,
		"ID": 973,
		"h": 12.5876176765
	},
	{
		"x": 28.5912082993,
		"y": 71.464377018,
		"ID": 974,
		"h": 19.9811918113
	},
	{
		"x": 28.5912082993,
		"y": 77.237882402,
		"ID": 975,
		"h": 7.1868865391
	},
	{
		"x": 28.5912082993,
		"y": 83.011387786,
		"ID": 976,
		"h": 5.3230385388
	},
	{
		"x": 28.5912082993,
		"y": 88.784893169,
		"ID": 977,
		"h": 3.2506387062
	},
	{
		"x": 28.5912082993,
		"y": 94.558398553,
		"ID": 978,
		"h": 1
	},
	{
		"x": 28.5912082993,
		"y": 100.331903937,
		"ID": 979,
		"h": 15.8173682807
	},
	{
		"x": 28.5912082993,
		"y": 106.105409321,
		"ID": 980,
		"h": 2.2607408045
	},
	{
		"x": 28.5912082993,
		"y": 111.878914704,
		"ID": 981,
		"h": 1.6562542699
	},
	{
		"x": 33.5912106303,
		"y": -75.760010269,
		"ID": 982,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -69.986504885,
		"ID": 983,
		"h": 2.4864482761
	},
	{
		"x": 33.5912106303,
		"y": -64.212999501,
		"ID": 984,
		"h": 1.234496002
	},
	{
		"x": 33.5912106303,
		"y": -58.439494117,
		"ID": 985,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -52.665988734,
		"ID": 986,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -46.89248335,
		"ID": 987,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -41.118977966,
		"ID": 988,
		"h": 1.9506755187
	},
	{
		"x": 33.5912106303,
		"y": -35.345472582,
		"ID": 989,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -29.571967198,
		"ID": 990,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -23.798461815,
		"ID": 991,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -18.024956431,
		"ID": 992,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -12.251451047,
		"ID": 993,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -6.477945663,
		"ID": 994,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": -0.704440279,
		"ID": 995,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": 5.069065104,
		"ID": 996,
		"h": 4.0241824165
	},
	{
		"x": 33.5912106303,
		"y": 10.842570488,
		"ID": 997,
		"h": 8.7744253614
	},
	{
		"x": 33.5912106303,
		"y": 16.616075872,
		"ID": 998,
		"h": 1.3237184412
	},
	{
		"x": 33.5912106303,
		"y": 22.389581256,
		"ID": 999,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": 28.163086639,
		"ID": 1000,
		"h": 7.8961891926
	},
	{
		"x": 33.5912106303,
		"y": 33.936592023,
		"ID": 1001,
		"h": 4.2685783297
	},
	{
		"x": 33.5912106303,
		"y": 39.710097407,
		"ID": 1002,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": 45.483602791,
		"ID": 1003,
		"h": 8.2329432442
	},
	{
		"x": 33.5912106303,
		"y": 51.257108175,
		"ID": 1004,
		"h": 13.1894891105
	},
	{
		"x": 33.5912106303,
		"y": 57.030613558,
		"ID": 1005,
		"h": 1
	},
	{
		"x": 33.5912106303,
		"y": 62.804118942,
		"ID": 1006,
		"h": 4.7660355899
	},
	{
		"x": 33.5912106303,
		"y": 68.577624326,
		"ID": 1007,
		"h": 10.1390752043
	},
	{
		"x": 33.5912106303,
		"y": 74.35112971,
		"ID": 1008,
		"h": 5.6039089355
	},
	{
		"x": 33.5912106303,
		"y": 80.124635094,
		"ID": 1009,
		"h": 6.2404911168
	},
	{
		"x": 33.5912106303,
		"y": 85.898140477,
		"ID": 1010,
		"h": 5.6287736393
	},
	{
		"x": 33.5912106303,
		"y": 91.671645861,
		"ID": 1011,
		"h": 5.5001435914
	},
	{
		"x": 33.5912106303,
		"y": 97.445151245,
		"ID": 1012,
		"h": 4.2202217588
	},
	{
		"x": 33.5912106303,
		"y": 103.218656629,
		"ID": 1013,
		"h": 2.6325924932
	},
	{
		"x": 33.5912106303,
		"y": 108.992162013,
		"ID": 1014,
		"h": 5.1759707635
	},
	{
		"x": 38.5912129613,
		"y": -78.646762961,
		"ID": 1015,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -72.873257577,
		"ID": 1016,
		"h": 3.2905433779
	},
	{
		"x": 38.5912129613,
		"y": -67.099752193,
		"ID": 1017,
		"h": 3.6044507294
	},
	{
		"x": 38.5912129613,
		"y": -61.326246809,
		"ID": 1018,
		"h": 4.1680383628
	},
	{
		"x": 38.5912129613,
		"y": -55.552741426,
		"ID": 1019,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -49.779236042,
		"ID": 1020,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -44.005730658,
		"ID": 1021,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -38.232225274,
		"ID": 1022,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -32.45871989,
		"ID": 1023,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -26.685214507,
		"ID": 1024,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -20.911709123,
		"ID": 1025,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -15.138203739,
		"ID": 1026,
		"h": 2.6206901452
	},
	{
		"x": 38.5912129613,
		"y": -9.364698355,
		"ID": 1027,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": -3.591192971,
		"ID": 1028,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": 2.182312412,
		"ID": 1029,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": 7.955817796,
		"ID": 1030,
		"h": 2.2465815402
	},
	{
		"x": 38.5912129613,
		"y": 13.72932318,
		"ID": 1031,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": 19.502828564,
		"ID": 1032,
		"h": 2.1952403075
	},
	{
		"x": 38.5912129613,
		"y": 25.276333948,
		"ID": 1033,
		"h": 1
	},
	{
		"x": 38.5912129613,
		"y": 31.049839331,
		"ID": 1034,
		"h": 2.0080589389
	},
	{
		"x": 38.5912129613,
		"y": 36.823344715,
		"ID": 1035,
		"h": 7.956220746
	},
	{
		"x": 38.5912129613,
		"y": 42.596850099,
		"ID": 1036,
		"h": 7.1538554166
	},
	{
		"x": 38.5912129613,
		"y": 48.370355483,
		"ID": 1037,
		"h": 11.5761510862
	},
	{
		"x": 38.5912129613,
		"y": 54.143860867,
		"ID": 1038,
		"h": 5.7942528457
	},
	{
		"x": 38.5912129613,
		"y": 59.91736625,
		"ID": 1039,
		"h": 14.8789883482
	},
	{
		"x": 38.5912129613,
		"y": 65.690871634,
		"ID": 1040,
		"h": 5.151721018
	},
	{
		"x": 38.5912129613,
		"y": 71.464377018,
		"ID": 1041,
		"h": 9.2800312045
	},
	{
		"x": 38.5912129613,
		"y": 77.237882402,
		"ID": 1042,
		"h": 23.7286417262
	},
	{
		"x": 38.5912129613,
		"y": 83.011387786,
		"ID": 1043,
		"h": 6.031374051
	},
	{
		"x": 38.5912129613,
		"y": 88.784893169,
		"ID": 1044,
		"h": 2.997163286
	},
	{
		"x": 38.5912129613,
		"y": 94.558398553,
		"ID": 1045,
		"h": 3.4218698657
	},
	{
		"x": 38.5912129613,
		"y": 100.331903937,
		"ID": 1046,
		"h": 5.2143397525
	},
	{
		"x": 38.5912129613,
		"y": 106.105409321,
		"ID": 1047,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -87.3070210364,
		"ID": 1048,
		"h": 2.2843973443
	},
	{
		"x": 43.5912152933,
		"y": -75.760010269,
		"ID": 1049,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -69.986504885,
		"ID": 1050,
		"h": 11.8135491541
	},
	{
		"x": 43.5912152933,
		"y": -64.212999501,
		"ID": 1051,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -58.439494117,
		"ID": 1052,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -52.665988734,
		"ID": 1053,
		"h": 3.714337623
	},
	{
		"x": 43.5912152933,
		"y": -46.89248335,
		"ID": 1054,
		"h": 1.3280637704
	},
	{
		"x": 43.5912152933,
		"y": -41.118977966,
		"ID": 1055,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -35.345472582,
		"ID": 1056,
		"h": 3.791859458
	},
	{
		"x": 43.5912152933,
		"y": -29.571967198,
		"ID": 1057,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -23.798461815,
		"ID": 1058,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -18.024956431,
		"ID": 1059,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -12.251451047,
		"ID": 1060,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -6.477945663,
		"ID": 1061,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": -0.704440279,
		"ID": 1062,
		"h": 3.1428675805
	},
	{
		"x": 43.5912152933,
		"y": 5.069065104,
		"ID": 1063,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": 10.842570488,
		"ID": 1064,
		"h": 2.1119851315
	},
	{
		"x": 43.5912152933,
		"y": 16.616075872,
		"ID": 1065,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": 22.389581256,
		"ID": 1066,
		"h": 3.8959153795
	},
	{
		"x": 43.5912152933,
		"y": 28.163086639,
		"ID": 1067,
		"h": 3.762174946
	},
	{
		"x": 43.5912152933,
		"y": 33.936592023,
		"ID": 1068,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": 39.710097407,
		"ID": 1069,
		"h": 1
	},
	{
		"x": 43.5912152933,
		"y": 45.483602791,
		"ID": 1070,
		"h": 5.3024568865
	},
	{
		"x": 43.5912152933,
		"y": 51.257108175,
		"ID": 1071,
		"h": 13.9653347318
	},
	{
		"x": 43.5912152933,
		"y": 57.030613558,
		"ID": 1072,
		"h": 6.7644320928
	},
	{
		"x": 43.5912152933,
		"y": 62.804118942,
		"ID": 1073,
		"h": 13.6959362106
	},
	{
		"x": 43.5912152933,
		"y": 68.577624326,
		"ID": 1074,
		"h": 4.7396200328
	},
	{
		"x": 43.5912152933,
		"y": 74.35112971,
		"ID": 1075,
		"h": 5.1823158195
	},
	{
		"x": 43.5912152933,
		"y": 80.124635094,
		"ID": 1076,
		"h": 6.375742773
	},
	{
		"x": 43.5912152933,
		"y": 85.898140477,
		"ID": 1077,
		"h": 4.7087869121
	},
	{
		"x": 43.5912152933,
		"y": 91.671645861,
		"ID": 1078,
		"h": 2.5154882265
	},
	{
		"x": 43.5912152933,
		"y": 97.445151245,
		"ID": 1079,
		"h": 3.6856832509
	},
	{
		"x": 43.5912152933,
		"y": 103.218656629,
		"ID": 1080,
		"h": 2.8725838268
	},
	{
		"x": 48.5912176243,
		"y": -90.1937737283,
		"ID": 1081,
		"h": 5.0045928638
	},
	{
		"x": 48.5912176243,
		"y": -84.4202683445,
		"ID": 1082,
		"h": 3.155224398
	},
	{
		"x": 48.5912176243,
		"y": -78.646762961,
		"ID": 1083,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -72.873257577,
		"ID": 1084,
		"h": 4.6695709979
	},
	{
		"x": 48.5912176243,
		"y": -67.099752193,
		"ID": 1085,
		"h": 7.9779392818
	},
	{
		"x": 48.5912176243,
		"y": -61.326246809,
		"ID": 1086,
		"h": 2.9802471823
	},
	{
		"x": 48.5912176243,
		"y": -55.552741426,
		"ID": 1087,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -49.779236042,
		"ID": 1088,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -44.005730658,
		"ID": 1089,
		"h": 2.2704140917
	},
	{
		"x": 48.5912176243,
		"y": -38.232225274,
		"ID": 1090,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -32.45871989,
		"ID": 1091,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -26.685214507,
		"ID": 1092,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -20.911709123,
		"ID": 1093,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": -15.138203739,
		"ID": 1094,
		"h": 1.7685040198
	},
	{
		"x": 48.5912176243,
		"y": -9.364698355,
		"ID": 1095,
		"h": 3.1080127078
	},
	{
		"x": 48.5912176243,
		"y": -3.591192971,
		"ID": 1096,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 2.182312412,
		"ID": 1097,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 7.955817796,
		"ID": 1098,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 13.72932318,
		"ID": 1099,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 19.502828564,
		"ID": 1100,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 25.276333948,
		"ID": 1101,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 31.049839331,
		"ID": 1102,
		"h": 1
	},
	{
		"x": 48.5912176243,
		"y": 36.823344715,
		"ID": 1103,
		"h": 2.3787611563
	},
	{
		"x": 48.5912176243,
		"y": 42.596850099,
		"ID": 1104,
		"h": 4.6661100904
	},
	{
		"x": 48.5912176243,
		"y": 48.370355483,
		"ID": 1105,
		"h": 5.9404178004
	},
	{
		"x": 48.5912176243,
		"y": 54.143860867,
		"ID": 1106,
		"h": 9.110437687
	},
	{
		"x": 48.5912176243,
		"y": 59.91736625,
		"ID": 1107,
		"h": 4.5951126084
	},
	{
		"x": 48.5912176243,
		"y": 65.690871634,
		"ID": 1108,
		"h": 4.5262775174
	},
	{
		"x": 48.5912176243,
		"y": 71.464377018,
		"ID": 1109,
		"h": 4.3712176974
	},
	{
		"x": 48.5912176243,
		"y": 77.237882402,
		"ID": 1110,
		"h": 7.5436821499
	},
	{
		"x": 48.5912176243,
		"y": 83.011387786,
		"ID": 1111,
		"h": 4.6561478238
	},
	{
		"x": 48.5912176243,
		"y": 88.784893169,
		"ID": 1112,
		"h": 11.0267409171
	},
	{
		"x": 48.5912176243,
		"y": 94.558398553,
		"ID": 1113,
		"h": 4.8896556339
	},
	{
		"x": 48.5912176243,
		"y": 100.331903937,
		"ID": 1114,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -104.6275371878,
		"ID": 1115,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -98.854031804,
		"ID": 1116,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -93.0805264202,
		"ID": 1117,
		"h": 2.4864482761
	},
	{
		"x": 53.5912199553,
		"y": -87.3070210364,
		"ID": 1118,
		"h": 7.1835276409
	},
	{
		"x": 53.5912199553,
		"y": -81.533515653,
		"ID": 1119,
		"h": 6.5999631478
	},
	{
		"x": 53.5912199553,
		"y": -75.760010269,
		"ID": 1120,
		"h": 5.0282108937
	},
	{
		"x": 53.5912199553,
		"y": -69.986504885,
		"ID": 1121,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -64.212999501,
		"ID": 1122,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -58.439494117,
		"ID": 1123,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -52.665988734,
		"ID": 1124,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -46.89248335,
		"ID": 1125,
		"h": 2.4377262036
	},
	{
		"x": 53.5912199553,
		"y": -41.118977966,
		"ID": 1126,
		"h": 1.2967753813
	},
	{
		"x": 53.5912199553,
		"y": -35.345472582,
		"ID": 1127,
		"h": 3.9786895812
	},
	{
		"x": 53.5912199553,
		"y": -29.571967198,
		"ID": 1128,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -23.798461815,
		"ID": 1129,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -18.024956431,
		"ID": 1130,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -12.251451047,
		"ID": 1131,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": -6.477945663,
		"ID": 1132,
		"h": 2.5372200226
	},
	{
		"x": 53.5912199553,
		"y": -0.704440279,
		"ID": 1133,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 5.069065104,
		"ID": 1134,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 10.842570488,
		"ID": 1135,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 16.616075872,
		"ID": 1136,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 22.389581256,
		"ID": 1137,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 28.163086639,
		"ID": 1138,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 33.936592023,
		"ID": 1139,
		"h": 1.511862669
	},
	{
		"x": 53.5912199553,
		"y": 39.710097407,
		"ID": 1140,
		"h": 1
	},
	{
		"x": 53.5912199553,
		"y": 45.483602791,
		"ID": 1141,
		"h": 8.5344144753
	},
	{
		"x": 53.5912199553,
		"y": 51.257108175,
		"ID": 1142,
		"h": 7.3280844833
	},
	{
		"x": 53.5912199553,
		"y": 57.030613558,
		"ID": 1143,
		"h": 6.2622868206
	},
	{
		"x": 53.5912199553,
		"y": 62.804118942,
		"ID": 1144,
		"h": 3.3288188092
	},
	{
		"x": 53.5912199553,
		"y": 68.577624326,
		"ID": 1145,
		"h": 3.4508510876
	},
	{
		"x": 53.5912199553,
		"y": 74.35112971,
		"ID": 1146,
		"h": 5.4375695652
	},
	{
		"x": 53.5912199553,
		"y": 80.124635094,
		"ID": 1147,
		"h": 5.9070003411
	},
	{
		"x": 53.5912199553,
		"y": 85.898140477,
		"ID": 1148,
		"h": 4.2126666109
	},
	{
		"x": 53.5912199553,
		"y": 91.671645861,
		"ID": 1149,
		"h": 3.6299140998
	},
	{
		"x": 53.5912199553,
		"y": 97.445151245,
		"ID": 1150,
		"h": 4.0103853217
	},
	{
		"x": 58.5912222863,
		"y": -101.7407844959,
		"ID": 1151,
		"h": 9.8449776812
	},
	{
		"x": 58.5912222863,
		"y": -95.9672791121,
		"ID": 1152,
		"h": 4.4031511698
	},
	{
		"x": 58.5912222863,
		"y": -90.1937737283,
		"ID": 1153,
		"h": 3.8218503091
	},
	{
		"x": 58.5912222863,
		"y": -84.4202683445,
		"ID": 1154,
		"h": 20.0823743233
	},
	{
		"x": 58.5912222863,
		"y": -78.646762961,
		"ID": 1155,
		"h": 6.4138752176
	},
	{
		"x": 58.5912222863,
		"y": -72.873257577,
		"ID": 1156,
		"h": 3.5209371674
	},
	{
		"x": 58.5912222863,
		"y": -67.099752193,
		"ID": 1157,
		"h": 7.851506412
	},
	{
		"x": 58.5912222863,
		"y": -61.326246809,
		"ID": 1158,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -55.552741426,
		"ID": 1159,
		"h": 2.2179359445
	},
	{
		"x": 58.5912222863,
		"y": -49.779236042,
		"ID": 1160,
		"h": 5.6977061807
	},
	{
		"x": 58.5912222863,
		"y": -44.005730658,
		"ID": 1161,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -38.232225274,
		"ID": 1162,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -32.45871989,
		"ID": 1163,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -26.685214507,
		"ID": 1164,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -20.911709123,
		"ID": 1165,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -15.138203739,
		"ID": 1166,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -9.364698355,
		"ID": 1167,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": -3.591192971,
		"ID": 1168,
		"h": 2.5209405673
	},
	{
		"x": 58.5912222863,
		"y": 2.182312412,
		"ID": 1169,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 7.955817796,
		"ID": 1170,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 13.72932318,
		"ID": 1171,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 19.502828564,
		"ID": 1172,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 25.276333948,
		"ID": 1173,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 31.049839331,
		"ID": 1174,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 36.823344715,
		"ID": 1175,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 42.596850099,
		"ID": 1176,
		"h": 9.5594646116
	},
	{
		"x": 58.5912222863,
		"y": 48.370355483,
		"ID": 1177,
		"h": 8.980258411
	},
	{
		"x": 58.5912222863,
		"y": 54.143860867,
		"ID": 1178,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 59.91736625,
		"ID": 1179,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 65.690871634,
		"ID": 1180,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 71.464377018,
		"ID": 1181,
		"h": 1
	},
	{
		"x": 58.5912222863,
		"y": 77.237882402,
		"ID": 1182,
		"h": 7.7099143672
	},
	{
		"x": 58.5912222863,
		"y": 83.011387786,
		"ID": 1183,
		"h": 4.7323553115
	},
	{
		"x": 58.5912222863,
		"y": 88.784893169,
		"ID": 1184,
		"h": 5.0630618339
	},
	{
		"x": 58.5912222863,
		"y": 94.558398553,
		"ID": 1185,
		"h": 3.0294288739
	},
	{
		"x": 58.5912222863,
		"y": 100.331903937,
		"ID": 1186,
		"h": 2.2580940411
	},
	{
		"x": 63.5912246183,
		"y": -104.6275371878,
		"ID": 1187,
		"h": 9.1290300816
	},
	{
		"x": 63.5912246183,
		"y": -98.854031804,
		"ID": 1188,
		"h": 3.1117654767
	},
	{
		"x": 63.5912246183,
		"y": -93.0805264202,
		"ID": 1189,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -87.3070210364,
		"ID": 1190,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -81.533515653,
		"ID": 1191,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -75.760010269,
		"ID": 1192,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -69.986504885,
		"ID": 1193,
		"h": 3.865932623
	},
	{
		"x": 63.5912246183,
		"y": -64.212999501,
		"ID": 1194,
		"h": 9.0275724417
	},
	{
		"x": 63.5912246183,
		"y": -58.439494117,
		"ID": 1195,
		"h": 2.6496015048
	},
	{
		"x": 63.5912246183,
		"y": -52.665988734,
		"ID": 1196,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -46.89248335,
		"ID": 1197,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -41.118977966,
		"ID": 1198,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -35.345472582,
		"ID": 1199,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -29.571967198,
		"ID": 1200,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -23.798461815,
		"ID": 1201,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -18.024956431,
		"ID": 1202,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -12.251451047,
		"ID": 1203,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -6.477945663,
		"ID": 1204,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": -0.704440279,
		"ID": 1205,
		"h": 2.5663898533
	},
	{
		"x": 63.5912246183,
		"y": 5.069065104,
		"ID": 1206,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": 10.842570488,
		"ID": 1207,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": 16.616075872,
		"ID": 1208,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": 22.389581256,
		"ID": 1209,
		"h": 6.2992697847
	},
	{
		"x": 63.5912246183,
		"y": 28.163086639,
		"ID": 1210,
		"h": 7.2280108685
	},
	{
		"x": 63.5912246183,
		"y": 33.936592023,
		"ID": 1211,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": 39.710097407,
		"ID": 1212,
		"h": 4.7524172337
	},
	{
		"x": 63.5912246183,
		"y": 45.483602791,
		"ID": 1213,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": 51.257108175,
		"ID": 1214,
		"h": 1
	},
	{
		"x": 63.5912246183,
		"y": 57.030613558,
		"ID": 1215,
		"h": 5.9545923577
	},
	{
		"x": 63.5912246183,
		"y": 62.804118942,
		"ID": 1216,
		"h": 6.2653470147
	},
	{
		"x": 63.5912246183,
		"y": 68.577624326,
		"ID": 1217,
		"h": 7.6887790757
	},
	{
		"x": 63.5912246183,
		"y": 74.35112971,
		"ID": 1218,
		"h": 11.2695176589
	},
	{
		"x": 63.5912246183,
		"y": 80.124635094,
		"ID": 1219,
		"h": 2.4729781644
	},
	{
		"x": 63.5912246183,
		"y": 85.898140477,
		"ID": 1220,
		"h": 3.9597634498
	},
	{
		"x": 63.5912246183,
		"y": 91.671645861,
		"ID": 1221,
		"h": 3.5303685099
	},
	{
		"x": 63.5912246183,
		"y": 97.445151245,
		"ID": 1222,
		"h": 4.8218681107
	},
	{
		"x": 68.5912269493,
		"y": -101.7407844959,
		"ID": 1223,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -78.646762961,
		"ID": 1224,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -72.873257577,
		"ID": 1225,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -67.099752193,
		"ID": 1226,
		"h": 4.5218344955
	},
	{
		"x": 68.5912269493,
		"y": -61.326246809,
		"ID": 1227,
		"h": 4.4592343963
	},
	{
		"x": 68.5912269493,
		"y": -55.552741426,
		"ID": 1228,
		"h": 1.3302220985
	},
	{
		"x": 68.5912269493,
		"y": -49.779236042,
		"ID": 1229,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -44.005730658,
		"ID": 1230,
		"h": 1.4374453832
	},
	{
		"x": 68.5912269493,
		"y": -38.232225274,
		"ID": 1231,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -32.45871989,
		"ID": 1232,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -26.685214507,
		"ID": 1233,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -20.911709123,
		"ID": 1234,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -15.138203739,
		"ID": 1235,
		"h": 3.1117654767
	},
	{
		"x": 68.5912269493,
		"y": -9.364698355,
		"ID": 1236,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": -3.591192971,
		"ID": 1237,
		"h": 2.5053275877
	},
	{
		"x": 68.5912269493,
		"y": 2.182312412,
		"ID": 1238,
		"h": 1.5277777423
	},
	{
		"x": 68.5912269493,
		"y": 7.955817796,
		"ID": 1239,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 13.72932318,
		"ID": 1240,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 19.502828564,
		"ID": 1241,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 25.276333948,
		"ID": 1242,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 31.049839331,
		"ID": 1243,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 36.823344715,
		"ID": 1244,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 42.596850099,
		"ID": 1245,
		"h": 2.9222619708
	},
	{
		"x": 68.5912269493,
		"y": 48.370355483,
		"ID": 1246,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 54.143860867,
		"ID": 1247,
		"h": 4.5920427359
	},
	{
		"x": 68.5912269493,
		"y": 59.91736625,
		"ID": 1248,
		"h": 1
	},
	{
		"x": 68.5912269493,
		"y": 65.690871634,
		"ID": 1249,
		"h": 2.6042285889
	},
	{
		"x": 68.5912269493,
		"y": 71.464377018,
		"ID": 1250,
		"h": 9.0409101256
	},
	{
		"x": 68.5912269493,
		"y": 77.237882402,
		"ID": 1251,
		"h": 6.1471760381
	},
	{
		"x": 68.5912269493,
		"y": 83.011387786,
		"ID": 1252,
		"h": 8.1315051207
	},
	{
		"x": 68.5912269493,
		"y": 88.784893169,
		"ID": 1253,
		"h": 3.804295394
	},
	{
		"x": 68.5912269493,
		"y": 94.558398553,
		"ID": 1254,
		"h": 11.1716434382
	},
	{
		"x": 68.5912269493,
		"y": 100.331903937,
		"ID": 1255,
		"h": 1.702846429
	},
	{
		"x": 73.5912292803,
		"y": -69.986504885,
		"ID": 1256,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -64.212999501,
		"ID": 1257,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -58.439494117,
		"ID": 1258,
		"h": 2.8247684979
	},
	{
		"x": 73.5912292803,
		"y": -52.665988734,
		"ID": 1259,
		"h": 2.1731788652
	},
	{
		"x": 73.5912292803,
		"y": -46.89248335,
		"ID": 1260,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -41.118977966,
		"ID": 1261,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -35.345472582,
		"ID": 1262,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -29.571967198,
		"ID": 1263,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -23.798461815,
		"ID": 1264,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -18.024956431,
		"ID": 1265,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -12.251451047,
		"ID": 1266,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": -6.477945663,
		"ID": 1267,
		"h": 1.6936956863
	},
	{
		"x": 73.5912292803,
		"y": -0.704440279,
		"ID": 1268,
		"h": 4.390857731
	},
	{
		"x": 73.5912292803,
		"y": 5.069065104,
		"ID": 1269,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 10.842570488,
		"ID": 1270,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 16.616075872,
		"ID": 1271,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 22.389581256,
		"ID": 1272,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 28.163086639,
		"ID": 1273,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 33.936592023,
		"ID": 1274,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 39.710097407,
		"ID": 1275,
		"h": 4.8344815571
	},
	{
		"x": 73.5912292803,
		"y": 45.483602791,
		"ID": 1276,
		"h": 1
	},
	{
		"x": 73.5912292803,
		"y": 51.257108175,
		"ID": 1277,
		"h": 3.9387507729
	},
	{
		"x": 73.5912292803,
		"y": 57.030613558,
		"ID": 1278,
		"h": 2.2991442008
	},
	{
		"x": 73.5912292803,
		"y": 62.804118942,
		"ID": 1279,
		"h": 4.3885779072
	},
	{
		"x": 73.5912292803,
		"y": 68.577624326,
		"ID": 1280,
		"h": 7.785407354
	},
	{
		"x": 73.5912292803,
		"y": 74.35112971,
		"ID": 1281,
		"h": 4.3995117597
	},
	{
		"x": 73.5912292803,
		"y": 80.124635094,
		"ID": 1282,
		"h": 6.4667629444
	},
	{
		"x": 73.5912292803,
		"y": 85.898140477,
		"ID": 1283,
		"h": 5.9990666795
	},
	{
		"x": 73.5912292803,
		"y": 91.671645861,
		"ID": 1284,
		"h": 2.8617269029
	},
	{
		"x": 73.5912292803,
		"y": 97.445151245,
		"ID": 1285,
		"h": 4.7656105134
	},
	{
		"x": 78.5912316113,
		"y": -61.326246809,
		"ID": 1286,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -55.552741426,
		"ID": 1287,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -49.779236042,
		"ID": 1288,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -44.005730658,
		"ID": 1289,
		"h": 2.8739379914
	},
	{
		"x": 78.5912316113,
		"y": -38.232225274,
		"ID": 1290,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -32.45871989,
		"ID": 1291,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -26.685214507,
		"ID": 1292,
		"h": 1.4480725048
	},
	{
		"x": 78.5912316113,
		"y": -20.911709123,
		"ID": 1293,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -15.138203739,
		"ID": 1294,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -9.364698355,
		"ID": 1295,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": -3.591192971,
		"ID": 1296,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 2.182312412,
		"ID": 1297,
		"h": 3.8878049822
	},
	{
		"x": 78.5912316113,
		"y": 7.955817796,
		"ID": 1298,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 13.72932318,
		"ID": 1299,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 19.502828564,
		"ID": 1300,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 25.276333948,
		"ID": 1301,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 31.049839331,
		"ID": 1302,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 36.823344715,
		"ID": 1303,
		"h": 3.5359054252
	},
	{
		"x": 78.5912316113,
		"y": 42.596850099,
		"ID": 1304,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 48.370355483,
		"ID": 1305,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 54.143860867,
		"ID": 1306,
		"h": 1
	},
	{
		"x": 78.5912316113,
		"y": 59.91736625,
		"ID": 1307,
		"h": 3.2211536017
	},
	{
		"x": 78.5912316113,
		"y": 65.690871634,
		"ID": 1308,
		"h": 8.9892727437
	},
	{
		"x": 78.5912316113,
		"y": 71.464377018,
		"ID": 1309,
		"h": 9.2215704483
	},
	{
		"x": 78.5912316113,
		"y": 77.237882402,
		"ID": 1310,
		"h": 4.7880956879
	},
	{
		"x": 78.5912316113,
		"y": 83.011387786,
		"ID": 1311,
		"h": 8.0503845329
	},
	{
		"x": 78.5912316113,
		"y": 88.784893169,
		"ID": 1312,
		"h": 3.8470227628
	},
	{
		"x": 78.5912316113,
		"y": 94.558398553,
		"ID": 1313,
		"h": 3.1785732368
	},
	{
		"x": 83.5912339433,
		"y": -52.665988734,
		"ID": 1314,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": -46.89248335,
		"ID": 1315,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": -41.118977966,
		"ID": 1316,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": -29.571967198,
		"ID": 1317,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": -23.798461815,
		"ID": 1318,
		"h": 1.7733989791
	},
	{
		"x": 83.5912339433,
		"y": -18.024956431,
		"ID": 1319,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": -12.251451047,
		"ID": 1320,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": -6.477945663,
		"ID": 1321,
		"h": 2.2930855474
	},
	{
		"x": 83.5912339433,
		"y": -0.704440279,
		"ID": 1322,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 5.069065104,
		"ID": 1323,
		"h": 3.4930604653
	},
	{
		"x": 83.5912339433,
		"y": 10.842570488,
		"ID": 1324,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 16.616075872,
		"ID": 1325,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 22.389581256,
		"ID": 1326,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 28.163086639,
		"ID": 1327,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 33.936592023,
		"ID": 1328,
		"h": 4.5431270854
	},
	{
		"x": 83.5912339433,
		"y": 39.710097407,
		"ID": 1329,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 45.483602791,
		"ID": 1330,
		"h": 3.4807287117
	},
	{
		"x": 83.5912339433,
		"y": 51.257108175,
		"ID": 1331,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 57.030613558,
		"ID": 1332,
		"h": 1
	},
	{
		"x": 83.5912339433,
		"y": 62.804118942,
		"ID": 1333,
		"h": 3.2858030937
	},
	{
		"x": 83.5912339433,
		"y": 68.577624326,
		"ID": 1334,
		"h": 2.6847276922
	},
	{
		"x": 83.5912339433,
		"y": 74.35112971,
		"ID": 1335,
		"h": 5.9066440212
	},
	{
		"x": 83.5912339433,
		"y": 80.124635094,
		"ID": 1336,
		"h": 3.3504200599
	},
	{
		"x": 83.5912339433,
		"y": 85.898140477,
		"ID": 1337,
		"h": 3.8182420237
	},
	{
		"x": 83.5912339433,
		"y": 91.671645861,
		"ID": 1338,
		"h": 3.5706045731
	},
	{
		"x": 88.5912362743,
		"y": -32.45871989,
		"ID": 1339,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": -26.685214507,
		"ID": 1340,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": -20.911709123,
		"ID": 1341,
		"h": 1.4890096127
	},
	{
		"x": 88.5912362743,
		"y": -15.138203739,
		"ID": 1342,
		"h": 1.234496002
	},
	{
		"x": 88.5912362743,
		"y": -9.364698355,
		"ID": 1343,
		"h": 1.9008470994
	},
	{
		"x": 88.5912362743,
		"y": -3.591192971,
		"ID": 1344,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 2.182312412,
		"ID": 1345,
		"h": 4.4398552623
	},
	{
		"x": 88.5912362743,
		"y": 7.955817796,
		"ID": 1346,
		"h": 3.3857470276
	},
	{
		"x": 88.5912362743,
		"y": 13.72932318,
		"ID": 1347,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 19.502828564,
		"ID": 1348,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 25.276333948,
		"ID": 1349,
		"h": 4.45383356
	},
	{
		"x": 88.5912362743,
		"y": 31.049839331,
		"ID": 1350,
		"h": 5.9768626381
	},
	{
		"x": 88.5912362743,
		"y": 36.823344715,
		"ID": 1351,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 42.596850099,
		"ID": 1352,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 48.370355483,
		"ID": 1353,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 54.143860867,
		"ID": 1354,
		"h": 1
	},
	{
		"x": 88.5912362743,
		"y": 59.91736625,
		"ID": 1355,
		"h": 4.9004617845
	},
	{
		"x": 88.5912362743,
		"y": 65.690871634,
		"ID": 1356,
		"h": 6.1059945464
	},
	{
		"x": 88.5912362743,
		"y": 71.464377018,
		"ID": 1357,
		"h": 19.1081092472
	},
	{
		"x": 88.5912362743,
		"y": 77.237882402,
		"ID": 1358,
		"h": 7.6951532975
	},
	{
		"x": 88.5912362743,
		"y": 83.011387786,
		"ID": 1359,
		"h": 9.698137249
	},
	{
		"x": 88.5912362743,
		"y": 88.784893169,
		"ID": 1360,
		"h": 6.664966912
	},
	{
		"x": 93.5912386053,
		"y": -46.89248335,
		"ID": 1361,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": -41.118977966,
		"ID": 1362,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": -35.345472582,
		"ID": 1363,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": -29.571967198,
		"ID": 1364,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": -23.798461815,
		"ID": 1365,
		"h": 1.2705576374
	},
	{
		"x": 93.5912386053,
		"y": -18.024956431,
		"ID": 1366,
		"h": 2.6266485768
	},
	{
		"x": 93.5912386053,
		"y": -12.251451047,
		"ID": 1367,
		"h": 1.351312449
	},
	{
		"x": 93.5912386053,
		"y": -6.477945663,
		"ID": 1368,
		"h": 6.1936302183
	},
	{
		"x": 93.5912386053,
		"y": -0.704440279,
		"ID": 1369,
		"h": 1.6697861294
	},
	{
		"x": 93.5912386053,
		"y": 5.069065104,
		"ID": 1370,
		"h": 5.7517878615
	},
	{
		"x": 93.5912386053,
		"y": 10.842570488,
		"ID": 1371,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": 16.616075872,
		"ID": 1372,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": 22.389581256,
		"ID": 1373,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": 28.163086639,
		"ID": 1374,
		"h": 5.0225184572
	},
	{
		"x": 93.5912386053,
		"y": 33.936592023,
		"ID": 1375,
		"h": 4.7083574721
	},
	{
		"x": 93.5912386053,
		"y": 39.710097407,
		"ID": 1376,
		"h": 4.5280536814
	},
	{
		"x": 93.5912386053,
		"y": 45.483602791,
		"ID": 1377,
		"h": 9.9028291504
	},
	{
		"x": 93.5912386053,
		"y": 51.257108175,
		"ID": 1378,
		"h": 1
	},
	{
		"x": 93.5912386053,
		"y": 57.030613558,
		"ID": 1379,
		"h": 4.9116624719
	},
	{
		"x": 93.5912386053,
		"y": 62.804118942,
		"ID": 1380,
		"h": 3.6856832509
	},
	{
		"x": 93.5912386053,
		"y": 68.577624326,
		"ID": 1381,
		"h": 5.3113965913
	},
	{
		"x": 93.5912386053,
		"y": 74.35112971,
		"ID": 1382,
		"h": 5.0180420583
	},
	{
		"x": 93.5912386053,
		"y": 80.124635094,
		"ID": 1383,
		"h": 10.0256220092
	},
	{
		"x": 93.5912386053,
		"y": 85.898140477,
		"ID": 1384,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -49.779236042,
		"ID": 1385,
		"h": 2.7782066415
	},
	{
		"x": 98.5912409363,
		"y": -44.005730658,
		"ID": 1386,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -38.232225274,
		"ID": 1387,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -32.45871989,
		"ID": 1388,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -26.685214507,
		"ID": 1389,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -20.911709123,
		"ID": 1390,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -15.138203739,
		"ID": 1391,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": -9.364698355,
		"ID": 1392,
		"h": 1.2778707869
	},
	{
		"x": 98.5912409363,
		"y": -3.591192971,
		"ID": 1393,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": 2.182312412,
		"ID": 1394,
		"h": 3.0885519506
	},
	{
		"x": 98.5912409363,
		"y": 7.955817796,
		"ID": 1395,
		"h": 12.9568364292
	},
	{
		"x": 98.5912409363,
		"y": 13.72932318,
		"ID": 1396,
		"h": 2.3969539928
	},
	{
		"x": 98.5912409363,
		"y": 19.502828564,
		"ID": 1397,
		"h": 6.8766787868
	},
	{
		"x": 98.5912409363,
		"y": 25.276333948,
		"ID": 1398,
		"h": 7.004036853
	},
	{
		"x": 98.5912409363,
		"y": 31.049839331,
		"ID": 1399,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": 36.823344715,
		"ID": 1400,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": 42.596850099,
		"ID": 1401,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": 48.370355483,
		"ID": 1402,
		"h": 1
	},
	{
		"x": 98.5912409363,
		"y": 54.143860867,
		"ID": 1403,
		"h": 4.7160823277
	},
	{
		"x": 98.5912409363,
		"y": 59.91736625,
		"ID": 1404,
		"h": 6.7759458254
	},
	{
		"x": 98.5912409363,
		"y": 65.690871634,
		"ID": 1405,
		"h": 7.3313920542
	},
	{
		"x": 98.5912409363,
		"y": 71.464377018,
		"ID": 1406,
		"h": 5.3102312439
	},
	{
		"x": 98.5912409363,
		"y": 77.237882402,
		"ID": 1407,
		"h": 6.5479240923
	},
	{
		"x": 98.5912409363,
		"y": 83.011387786,
		"ID": 1408,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": -52.665988734,
		"ID": 1409,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": -46.89248335,
		"ID": 1410,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": -41.118977966,
		"ID": 1411,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": -35.345472582,
		"ID": 1412,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": -29.571967198,
		"ID": 1413,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": -23.798461815,
		"ID": 1414,
		"h": 1.6724706493
	},
	{
		"x": 103.5912432683,
		"y": -18.024956431,
		"ID": 1415,
		"h": 2.7222382687
	},
	{
		"x": 103.5912432683,
		"y": -12.251451047,
		"ID": 1416,
		"h": 1.9303101566
	},
	{
		"x": 103.5912432683,
		"y": -6.477945663,
		"ID": 1417,
		"h": 3.5064670767
	},
	{
		"x": 103.5912432683,
		"y": -0.704440279,
		"ID": 1418,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": 5.069065104,
		"ID": 1419,
		"h": 2.2179359445
	},
	{
		"x": 103.5912432683,
		"y": 10.842570488,
		"ID": 1420,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": 16.616075872,
		"ID": 1421,
		"h": 5.2446325586
	},
	{
		"x": 103.5912432683,
		"y": 22.389581256,
		"ID": 1422,
		"h": 3.2816499627
	},
	{
		"x": 103.5912432683,
		"y": 28.163086639,
		"ID": 1423,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": 33.936592023,
		"ID": 1424,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": 62.804118942,
		"ID": 1425,
		"h": 1
	},
	{
		"x": 103.5912432683,
		"y": 68.577624326,
		"ID": 1426,
		"h": 6.812305505
	},
	{
		"x": 103.5912432683,
		"y": 74.35112971,
		"ID": 1427,
		"h": 8.9016747889
	},
	{
		"x": 103.5912432683,
		"y": 80.124635094,
		"ID": 1428,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": -55.552741426,
		"ID": 1429,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": -49.779236042,
		"ID": 1430,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": -44.005730658,
		"ID": 1431,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": -38.232225274,
		"ID": 1432,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": -32.45871989,
		"ID": 1433,
		"h": 1.5387303435
	},
	{
		"x": 108.5912455993,
		"y": -26.685214507,
		"ID": 1434,
		"h": 1.1547096648
	},
	{
		"x": 108.5912455993,
		"y": -20.911709123,
		"ID": 1435,
		"h": 1.6724706493
	},
	{
		"x": 108.5912455993,
		"y": -15.138203739,
		"ID": 1436,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": -9.364698355,
		"ID": 1437,
		"h": 1.5840897846
	},
	{
		"x": 108.5912455993,
		"y": -3.591192971,
		"ID": 1438,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": 2.182312412,
		"ID": 1439,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": 7.955817796,
		"ID": 1440,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": 13.72932318,
		"ID": 1441,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": 19.502828564,
		"ID": 1442,
		"h": 1.5387303435
	},
	{
		"x": 108.5912455993,
		"y": 25.276333948,
		"ID": 1443,
		"h": 3.8562325793
	},
	{
		"x": 108.5912455993,
		"y": 31.049839331,
		"ID": 1444,
		"h": 1
	},
	{
		"x": 108.5912455993,
		"y": 71.464377018,
		"ID": 1445,
		"h": 6.2456049005
	},
	{
		"x": 108.5912455993,
		"y": 77.237882402,
		"ID": 1446,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -52.665988734,
		"ID": 1447,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -46.89248335,
		"ID": 1448,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -41.118977966,
		"ID": 1449,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -35.345472582,
		"ID": 1450,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -29.571967198,
		"ID": 1451,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -23.798461815,
		"ID": 1452,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -18.024956431,
		"ID": 1453,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -12.251451047,
		"ID": 1454,
		"h": 1.8398956464
	},
	{
		"x": 113.5912479303,
		"y": -6.477945663,
		"ID": 1455,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": -0.704440279,
		"ID": 1456,
		"h": 3.757468474
	},
	{
		"x": 113.5912479303,
		"y": 5.069065104,
		"ID": 1457,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": 10.842570488,
		"ID": 1458,
		"h": 1
	},
	{
		"x": 113.5912479303,
		"y": 16.616075872,
		"ID": 1459,
		"h": 2.9249228487
	},
	{
		"x": 113.5912479303,
		"y": 22.389581256,
		"ID": 1460,
		"h": 3.4548110701
	},
	{
		"x": 113.5912479303,
		"y": 28.163086639,
		"ID": 1461,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -49.779236042,
		"ID": 1462,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -44.005730658,
		"ID": 1463,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -38.232225274,
		"ID": 1464,
		"h": 2.1592490082
	},
	{
		"x": 118.5912502613,
		"y": -32.45871989,
		"ID": 1465,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -26.685214507,
		"ID": 1466,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -20.911709123,
		"ID": 1467,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -15.138203739,
		"ID": 1468,
		"h": 1.9129270429
	},
	{
		"x": 118.5912502613,
		"y": -9.364698355,
		"ID": 1469,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": -3.591192971,
		"ID": 1470,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": 2.182312412,
		"ID": 1471,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": 7.955817796,
		"ID": 1472,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": 13.72932318,
		"ID": 1473,
		"h": 3.2614054409
	},
	{
		"x": 118.5912502613,
		"y": 19.502828564,
		"ID": 1474,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": 25.276333948,
		"ID": 1475,
		"h": 1
	},
	{
		"x": 118.5912502613,
		"y": 31.049839331,
		"ID": 1476,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": -46.89248335,
		"ID": 1477,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": -41.118977966,
		"ID": 1478,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": -35.345472582,
		"ID": 1479,
		"h": 2.4506111317
	},
	{
		"x": 123.5912525933,
		"y": -29.571967198,
		"ID": 1480,
		"h": 5.265791148
	},
	{
		"x": 123.5912525933,
		"y": -23.798461815,
		"ID": 1481,
		"h": 2.6273923576
	},
	{
		"x": 123.5912525933,
		"y": -18.024956431,
		"ID": 1482,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": -12.251451047,
		"ID": 1483,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": -6.477945663,
		"ID": 1484,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": -0.704440279,
		"ID": 1485,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": 5.069065104,
		"ID": 1486,
		"h": 6.832334087
	},
	{
		"x": 123.5912525933,
		"y": 10.842570488,
		"ID": 1487,
		"h": 4.0604459313
	},
	{
		"x": 123.5912525933,
		"y": 16.616075872,
		"ID": 1488,
		"h": 1
	},
	{
		"x": 123.5912525933,
		"y": 22.389581256,
		"ID": 1489,
		"h": 1.7080399174
	},
	{
		"x": 123.5912525933,
		"y": 28.163086639,
		"ID": 1490,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": -44.005730658,
		"ID": 1491,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": -38.232225274,
		"ID": 1492,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": -32.45871989,
		"ID": 1493,
		"h": 3.1889648949
	},
	{
		"x": 128.5912549243,
		"y": -26.685214507,
		"ID": 1494,
		"h": 3.9757065824
	},
	{
		"x": 128.5912549243,
		"y": -20.911709123,
		"ID": 1495,
		"h": 2.148024278
	},
	{
		"x": 128.5912549243,
		"y": -15.138203739,
		"ID": 1496,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": -9.364698355,
		"ID": 1497,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": -3.591192971,
		"ID": 1498,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": 2.182312412,
		"ID": 1499,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": 7.955817796,
		"ID": 1500,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": 13.72932318,
		"ID": 1501,
		"h": 1
	},
	{
		"x": 128.5912549243,
		"y": 19.502828564,
		"ID": 1502,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -52.665988734,
		"ID": 1503,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -46.89248335,
		"ID": 1504,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -41.118977966,
		"ID": 1505,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -35.345472582,
		"ID": 1506,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -29.571967198,
		"ID": 1507,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -23.798461815,
		"ID": 1508,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -18.024956431,
		"ID": 1509,
		"h": 3.1310844432
	},
	{
		"x": 133.5912572553,
		"y": -12.251451047,
		"ID": 1510,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -6.477945663,
		"ID": 1511,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": -0.704440279,
		"ID": 1512,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": 5.069065104,
		"ID": 1513,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": 10.842570488,
		"ID": 1514,
		"h": 1
	},
	{
		"x": 133.5912572553,
		"y": 16.616075872,
		"ID": 1515,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -61.326246809,
		"ID": 1516,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -55.552741426,
		"ID": 1517,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -49.779236042,
		"ID": 1518,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -44.005730658,
		"ID": 1519,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -38.232225274,
		"ID": 1520,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -32.45871989,
		"ID": 1521,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -26.685214507,
		"ID": 1522,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -20.911709123,
		"ID": 1523,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -15.138203739,
		"ID": 1524,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -9.364698355,
		"ID": 1525,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": -3.591192971,
		"ID": 1526,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": 2.182312412,
		"ID": 1527,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": 7.955817796,
		"ID": 1528,
		"h": 1
	},
	{
		"x": 138.5912595863,
		"y": 13.72932318,
		"ID": 1529,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -58.439494117,
		"ID": 1530,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -52.665988734,
		"ID": 1531,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -46.89248335,
		"ID": 1532,
		"h": 3.8883123267
	},
	{
		"x": 143.5912619183,
		"y": -41.118977966,
		"ID": 1533,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -35.345472582,
		"ID": 1534,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -23.798461815,
		"ID": 1535,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -18.024956431,
		"ID": 1536,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -12.251451047,
		"ID": 1537,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": -6.477945663,
		"ID": 1538,
		"h": 2.7956745387
	},
	{
		"x": 143.5912619183,
		"y": -0.704440279,
		"ID": 1539,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": 5.069065104,
		"ID": 1540,
		"h": 1
	},
	{
		"x": 143.5912619183,
		"y": 10.842570488,
		"ID": 1541,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -61.326246809,
		"ID": 1542,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -55.552741426,
		"ID": 1543,
		"h": 2.4618231679
	},
	{
		"x": 148.5912642493,
		"y": -49.779236042,
		"ID": 1544,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -44.005730658,
		"ID": 1545,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -38.232225274,
		"ID": 1546,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -15.138203739,
		"ID": 1547,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -9.364698355,
		"ID": 1548,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": -3.591192971,
		"ID": 1549,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": 2.182312412,
		"ID": 1550,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": 7.955817796,
		"ID": 1551,
		"h": 1
	},
	{
		"x": 148.5912642493,
		"y": 13.72932318,
		"ID": 1552,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": -18.024956431,
		"ID": 1553,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": -12.251451047,
		"ID": 1554,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": -6.477945663,
		"ID": 1555,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": -0.704440279,
		"ID": 1556,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": 5.069065104,
		"ID": 1557,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": 10.842570488,
		"ID": 1558,
		"h": 1
	},
	{
		"x": 153.5912665803,
		"y": 16.616075872,
		"ID": 1559,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": -20.911709123,
		"ID": 1560,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": -15.138203739,
		"ID": 1561,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": -9.364698355,
		"ID": 1562,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": -3.591192971,
		"ID": 1563,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": 2.182312412,
		"ID": 1564,
		"h": 4.4574347425
	},
	{
		"x": 158.5912689113,
		"y": 7.955817796,
		"ID": 1565,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": 13.72932318,
		"ID": 1566,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": 19.502828564,
		"ID": 1567,
		"h": 1
	},
	{
		"x": 158.5912689113,
		"y": 25.276333948,
		"ID": 1568,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": -23.798461815,
		"ID": 1569,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": -18.024956431,
		"ID": 1570,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": -12.251451047,
		"ID": 1571,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": -6.477945663,
		"ID": 1572,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": -0.704440279,
		"ID": 1573,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": 5.069065104,
		"ID": 1574,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": 10.842570488,
		"ID": 1575,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": 16.616075872,
		"ID": 1576,
		"h": 1
	},
	{
		"x": 163.5912712433,
		"y": 22.389581256,
		"ID": 1577,
		"h": 2.1824044713
	},
	{
		"x": 163.5912712433,
		"y": 28.163086639,
		"ID": 1578,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": -26.685214507,
		"ID": 1579,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": -20.911709123,
		"ID": 1580,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": -15.138203739,
		"ID": 1581,
		"h": 2.7613291573
	},
	{
		"x": 168.5912735743,
		"y": -3.591192971,
		"ID": 1582,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": 2.182312412,
		"ID": 1583,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": 7.955817796,
		"ID": 1584,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": 13.72932318,
		"ID": 1585,
		"h": 2.2991442008
	},
	{
		"x": 168.5912735743,
		"y": 19.502828564,
		"ID": 1586,
		"h": 1
	},
	{
		"x": 168.5912735743,
		"y": 25.276333948,
		"ID": 1587,
		"h": 1
	},
	{
		"x": 173.5912759053,
		"y": -23.798461815,
		"ID": 1588,
		"h": 1
	},
	{
		"x": 173.5912759053,
		"y": -18.024956431,
		"ID": 1589,
		"h": 1
	},
	{
		"x": 173.5912759053,
		"y": 16.616075872,
		"ID": 1590,
		"h": 1
	}
];


//////////////////
// WEBPACK FOOTER
// ../res/centers.json
// module id = 15
// module chunks = 0